import { template } from "@babel/core"
import LocalizedStrings from "react-localization"

export default new LocalizedStrings({
	/* cSpell:enable */
	/* cSpell.language:pt,pt_PT */
	pt: {
		// Generic
		generic: {
			askToSave: "Deseja guardar as alterações antes de sair da página?",
			edit: "Editar",
			done: "Concluir",
			accept: "Aceitar",
			cancel: "Cancelar",
			remove: "Remover",
			forget: "Esquecer User",
			delete: "Eliminar",
			deleteMessage: "Tem a certeza que deseja eliminar?",
			success: "Sucesso",
			active: "Ativar",
			expand: "Expandir",
			toggle: "Toggle",
			save: "Guardar",
			yes: "Sim",
			no: "Não",
			apply: "Aplicar",
			item: "Artigo",
			items: "Artigos",
			submit: "Submeter",
			continue: "Continuar",
			confirm: "Confirmar",
			finish: "Terminar",
			back: "Voltar",
			oops: "Oops",
			error: "Erro",
			retry: "Tentar novamente",
			reset: "Reset",
			search: "Pesquisar",
			noResults: "Sem Resultados",
			clickHereTo: "Clique para {0}",
			requiredField: "{0} é um campo obrigatório",
			duplicateEmail:
				"Este email já está a ser utilizado. Por favor utilize outro email.",
			emptyList: "Sem {0} na lista",
			leavePage: "Sair da Página?",
			leave: "Sair",
			stay: "Ficar",
			open: "Abrir",
			close: "Fechar",
			change: "Mudar",
			next: "Seguinte",
			or: "ou",
			free: "Grátis",
			send: "Enviar",
			selected: "Selecionado",
			selecteds: "Selecionados",
			swalEditTitle: "Cancelar Alteração?",
			swalEditDescription:
				"Cancelar edição vai apagar toda a informação não guardada",
			leaveDescription:
				"Ao sair desta página vai apagar toda a informação não guardada",
			swalDeleteTitle: "Apagar {0}?",
			swalDeleteDescription:
				"Ao sair desta página vai apagar todos os {0} na sua lista",
			genericSelect: "Selecionar {0}",
			select: "Selecionar",
			addGeneric: "Adicionar {0}",
			moreOptions: "Mais Opções",
			all: "Tudo",
			filter: "Filtrar",
			clear: "Limpar filtro",
			enable: "Ativar",
			newF: "Nova",
			newM: "Novo",
			addNewF: "Adicionar nova {0}",
			addNewM: "Adicionar novo {0}",
			default: "Pré-Definido",
			editGeneric: "Editar {0}",
			infinite: "Infinito",
			details: "Detalhes",
			noItemsSelected: "Nenhum Item Selecionado",
			clearList: "Limpar lista",
			loading: "A Carregar...",
			view: "Ver",
			actions: "Ações",
			invalidUrl: "URL inválido. Por favor remova o prefixo HTTP.",
			shop: "Loja",
			noEntries: "Sem Valores",
			chatWalktroughText1:
				"Adicionámos diversas FAQ que podem ajudar a conhecer e entender como funciona o produto Shop2Grow. Essas FAQ estão disponíveis no ícone de chat no canto inferior direito do ecrã.",
			chatWalktroughText2:
				"Estamos também disponíveis, através de chat, para ajudar na melhor maneira de criar e definir a sua loja.",
			skip: "Saltar Walkthrough",
			walkTrough: "Walkthrough",
			clone: "Clonar",
			download: "Download",
			upload: "Upload",
			template: "Download Template",
			export: "Exportar",
			import: "Importar",
			defaultItem: "um item",
			defaultItemRecipient: "este/esta {0}",
			demo: "Demo",
			previewOnly: "Apenas Preview",
			selectPaymentMethod:
				"Por favor, selecione um método de pagamento antes de atualizar a sua subscrição.",
			basic: "Básico",
			advanced: "Avançado",
			editMode: "Modo de Edição",
			print: "Imprimir",
			code: "Codigo",
			filters: "Filtros",
			changeImage:
				"Clique para adicionar uma imagem ou arraste o ficheiro para esta caixa.",
			changeFile:
				"Clique para adicionar um ficheiro ou arraste-o para esta caixa.",
			userImage: `Este utilizador ainda não tem imagem`,
			changeVideo:
				"Clique para adicionar um ficheiro de video ou arraste o ficheiro para esta caixa.",
			changeYoutubeVideo: "Insira um link de youtube",
			changeAudio:
				"Clique para adicionar um ficheiro de áudio ou arraste o ficheiro para esta caixa.",
			everyF: "Todas",
			everyM: "Todos",
			generalInformation: "Informação Geral",
			sync: "Sincronizar",
			map: "Mapa",
			bundled: "Agrupadas",
		},

		notifications: {
			title: "Notificações",
			permissionDenied:
				"Notificações não permitidas. Por favor, ative as notificações nas definições do seu browser.",
			routeCreated: "Otimizador",
			routeCreatedBody:
				"As rotas para o dia {0} foram criadas com sucesso para {1} com o contrato {2}.",
			routeCreatedError: "Erro ao criar rotas.",
			routeCreatedErrorBody:
				"Erro ao criar rotas. Por favor, verifique os dados introduzidos.",
			newNotificationTitle: "Nova Notificação",
			newNotificationBody: "Tem uma nova mensagem.",
		},

		fields: {
			name: "Nome",
			externalName: "Nome Externo",
			address: "Morada",
			addresses: "Moradas",
			country: "País",
			state: "Estado",
			city: "Cidade",
			zipCode: "Código Postal",
			description: "Descrição",
			phone: "Telefone",
			phoneNumber: "Número de Telefone",
			phoneShort: "Tel.:",
			mobilePhone: "Telemóvel",
			email: "Email",
			seoUrl: "SEO Url",
			tags: "Tags",
			ccNumber: "Número do CC",
			billingAddress: "Morada de Faturação",
			shippingAddress: "Morada de Envio",
			vat: "VAT",
			password: "Password",
			message: "Mensagem",
			image: "Imagem",
			images: "Imagens",
			imgPlaceholder:
				"Tente arrastar imagens para aqui, ou clique para fazer upload",
			filesPlaceholder:
				"Tente arrastar o ficheiro para aqui ou clique para selecionar o ficheiro",
			subTotal: "Subtotal",
			total: "Total",
			quantity: "Quantidade",
			ordered: "Qtd. Encomendada",
			totalQuantity: "Quantidade Total",
			discount: "Desconto",
			registerDate: "Data Registo",
			invalidEmail: "Email não é valido",
			tax: "Taxa",
			addedOn: "Adicionado",
			startDate: "Data Inicial",
			endDate: "Data Final",
			startHour: "Hora Inicial",
			endHour: "Hora Final",
			filename: "Nome do Ficheiro",
			gender: "Género",
			waitingForResults: "À espera do nome ou SKU...",
			link: "Link",
			date: "Data",
			otherRegions: "Outras Zonas",
			taxValues: "Taxas",
			previewLink: "Link de Pré-Visualização",
			clickToUpload: "Clique para fazer o Upload",
			photo: "Foto",
			shift: "Turno",
			defaultShift: "Turno Padrão",
			shiftEnd: "Fim de Turno",
			shiftStart: "Início de Turno",
			contractTypeName: "Nome do Contrato",
			contractTypeUrl: "Url optimizador",
			isActive: "Ativo",

			// Select
			selectCountry: "Selecionar País",
			selectState: "Selecionar Estado",
			selectFilters: "Selecionar Filtros",
			selectDiscount: "Selecionar Desconto",

			countries: "Países",
			states: "Estados",

			// Pairs
			valuePair: "{0} / {1}",
			placeHolderPair: "{0} => {1}",

			code: "Abreviatura",
			bccEmail: "Email para receber encomendas",
			article: "Artigo",

			logo: "Logo",
			category: "Categoria",
			weight: "Peso",

			// SMS Options
			deliverySlotRangeMinutes: "Intervalo da entrega (ETD - X to ETD + X)",
			template: "Template",

			// Email
			subject: "Assunto",
			recipients: "Destinatários",

			loadSequenceType: "Tipo de Carregamento",

			// Service Times
			serviceTimeA: "Tempo de Serviço Base",
			serviceTimeB: "Tempo de Serviço Por Caixa",

			addressNotes: "Notas de Endereço",

			// Label Template
			labelTemplate: "Template da Etiqueta",
		},

		language: {
			header: "Idioma",
			defaultLanguage: "Idioma Padrão",
			languageNotActive:
				"Guarde as atualizações antes de proceder à alteração do idioma padrão.",
			portuguese: "Português",
			english: "Inglês",
			german: "Alemão",
			french: "Francês",
			spanish: "Espanhol",
		},

		sidebar: {
			dashboard: "Dashboard",
			profile: "Perfil",
			information: "Informação",
			staff: "Staff",
			operationLinks: "Links de Operações",
			settings: "Definições",
			logs: "Logs",
			users: "Utilizadores",
			businesses: "Clientes",
			orders: "Encomendas",
			routes: "Rotas",
			tenants: "Tenants",
			externalDeliveries: "Entregas Externas",
			messaging: "Mensagens",
			sectorsMap: "Mapa de Setores",
			groups: {
				general: "Geral",
				operations: "Operações",
				team: "Equipa",
				system: "Sistema",
			},
		},

		header: {
			account: "Conta",
		},

		// Screens
		authentication: {
			welcome: "Bem-vindo",
			header: "Autenticação",
			register: "Registo",
			login: "Entrar",
			logout: "Sair",
			signIn: "Autenticar",
			confirmAccount: "Confirmar Conta",
			name: "Nome",
			namePlaceholder: "O seu nome",
			email: "Email",
			emailPlaceholder: "O seu email",
			password: "Password",
			passwordPlaceholder: "A sua password",
			newPassword: "Nova password",
			newPasswordPlaceholder: "Inserir nova password",
			confirmPassword: "Confirmar Password",
			confirmPasswordPlaceholder: "Repetir a password",
			forgotPassword: "Esqueceu-se da password?",
			loginFooter: "Não tem conta? Registe-se aqui",
			registerFooter: "Já tem conta? Autentique-se aqui.",
			resendCode1: "Não recebeu o seu código de confirmação? ",
			resendCode2: "Reenviar código de ativação",
			sendEmail: "Enviar Email",
			recoverPassword: "Recuperar password",
			changePassword: "Mudar Password",
			changeEmail: "Mudar Email",
			newEmail: "Novo Email",
			newEmailConfirm: "Confirmar Novo Email",
			repeatEmail: "Repetir Email",
			currentEmail: "Email Atual",
			currentPassword: "Password Atual",
			emailSent: "Email Enviado com Sucesso",
			repeatPassword: "Repetir Password",
			rememberedPassword: "Lembrou-se da password?",
			adminPassword: "Password do Administrador",
			notLoggedIn:
				"Necessita de estar autenticado para ter acesso a esta página",
			noMatchPassword: "As passwords não coincidem",
			acceptSubtitle:
				"Por favor insira uma password para confirmar a sua conta.",
			confirmInvite: "Por favor insira a sua password para aceitar o convite.",
			goBackToLogin: "Ir para o ecrã de início de sessão",
			resendInviteEmail: "Reenviar email de convite",
			confirmResendInviteEmail: "Reenviar email de convite para {0}?",
			signInFailed: "Falha na autenticação",
			signInFailedTryAgain: "Falha na autenticação. Por favor tente novamente.",
			notAuthorized: "Acesso não autorizado",
			notAuthorizedDescription:
				"A sua conta ainda não tem acesso ao backoffice. Contacte um administrador.",
			welcomeBack: "Bem-vindo de volta",
			enterPassword: "Insira a sua password",
			signInSubtitle: "Inicie sessão na sua conta Dingoo",
			signingInAs: "A iniciar sessão como",
			continueWithGoogle: "Continuar com Google",
			forgetTitle:
				"Tem a certeza que deseja esquecer o utilizador {0}? Esta ação irá deixar o utilizar sem acesso à app, e todos os dados serão removidos.",
			forgetConfirm: "Esquecer Utilizador",
			backoffice: "Backoffice",
		},

		acceptInvite: {
			header: "Aceitar Convite",
			title: "Olá {0}, {1} convidou-o(a) a pertencer a {2}.",
			title2: "Olá {0}, {1} convidou-o(a) para gerir {2}.",
			subTitle: "Insira uma password para confirmar a sua conta",
			expired: "Este convite expirou",
		},

		notFound: {
			header: "Página Inexistente",
		},

		importModal: {
			fileName: "Nome do Ficheiro",
			size: "Tamanho",
			import: "Importar",
		},

		errors: {
			invalidArgs: "Argumentos inválidos ou em falta",
			invalidFields: "Campos inválidos ou em falta",
			emailIsInvalid: "O formato de email inserido não é válido",
			fillEmail: "Insira um email por favor",
			fillPassword: "Insira uma password por favor",
			pleaseFillFormCorrectly: "Por favor preencha o formulário correctamente",
			fillField: "Este campo é de preenchimento obrigatório",
			notSupportedFile: "Tipo de ficheiro não suportado",
			nameIsEmpty: "O campo nome é de preenchimento obrigatório",
			passwordsDontMatch:
				"Os campos 'Nova password' e 'Confirmar password' não coincidem",
			emailIsEmpty: "O campo email é de preenchimento obrigatório",
			fileTooBigorInvalid:
				"O tamanho da imagem é superior a 8MB ou tem um formato inválido",
			unsupportedFile: "Ficheiro não suportado",
			fileNotSupported: "O ficheiro que tentou carregar, não é suportado.",
			processingError: "Erro de Processamento",
			imageProcessingError: "{images} não puderam ser processadas.",
			shiftDateError:
				"A hora de início de turno tem de ser uma hora anterior à hora de final de turno.",
		},

		profile: {
			profilePicture: "Foto de Perfil",
			role: "Cargo",
			editedSuccessfully: "Perfil editado com sucesso",
			recurrence: "Recorrência",
			recurrenceActive: "Ativar Recorrência",
			recurrenceUntil: "Recorrente até",
			recurringEndMissing: "A data final de recorrência é obrigatória.",
			recurrenceSuccess: "Definições de recorrência guardadas com sucesso.",
			deleteRecurrence: "Eliminar recorrência",
			noThankYou: "Não Obrigado(a)",
			recurrenceTooltip: "Criar recorrência",
			deleteRecurrenceDescription:
				"Pretende eliminar a recorrência do dia {date}?",
		},

		placeholders: {
			name: "O seu nome",
			email: "o_seu@email.com",
			phoneNumber: "+351265000000",
			language: "Selecione uma língua",
			languageSimplified: "Língua",
			role: "Selecione um cargo",
			currentPassword: "password actual",
			newPassword: "nova password",
			confirmPassword: "nova password",
			newEmail: "novo@email.com",
			page: "pagina",
			titlePage: "Título da Página",
			link: "https://www.google.com/",
		},

		staff: {
			owner: "Dono",
			owners: "Donos",
			admin: "Administrador",
			marketing: "Marketing",
			editedSuccessfully: "Utilizador editado com sucesso",
			passwordChangedSuccessfully: "Password alterada com sucesso",
			emailChangedSuccessfully: "Email alterado com sucesso",
			wrongPassword: "Password Errada",
			emailInUse: "Email em uso",
			status: "Estado",
			confirmed: "Confirmado",
			pending: "Pendente",
			createStaff: "Criar Utilizador",
			createdSuccessfully: "Utilizador criado com sucesso.",
			sysAdmin: "System Admin",
			addStaff: "Adicionar Utilizador",
			editStaff: "Editar Utilizador",
			addOwner: "Adicionar Dono",
			editOwner: "Editar Dono",
			user: "Utilizador",
			archiveStaff: "Arquivar Utilizador",
			archived: "Utilizador arquivado com sucesso.",
			removed: "Utilizador foi removido com sucesso.",
			disableStaff: "Desativar um Utilizador",
			enableStaff: "Ativar Utilizador",
			disabled: "Utilizador desativado com sucesso.",
			enabled: "Utilizador ativado com sucesso.",
			manager: "Gestor",
			supervisor: "Supervisor",
			dispatcher: "Expedidor",
			driver: "Motorista",
			drivers: "Motoristas",
			operator: "Operador",
			operators: "Operadores",
			dashboardUser: "Utilizador de Dashboard",
			serviceAccount: "Service Account (apenas API)",

			// Drivers
			expectedWorkingHours: "Horas de Trabalho Esperadas por Dia",
			expectedWorkingDays: "Dias de Trabalho Esperados por Semana",

			// Firebase
			firebaseUser: "Conta Scanner",
			firebaseUserLinked: "Associado",
			firebaseUserNotLinked: "Não Associado",
			linkFirebaseUser: "Associar Conta",
			firebaseUserLinkedSuccessfully: "Scanner associado com sucesso.",
			noBackofficeAccess: "Esta conta não tem acesso ao backoffice.",
			noPasswordWarning:
				"Sem password, o utilizador só poderá entrar com Google ou através do link de definição de password enviado por email. Se necessário acesso por email e password, defina uma password agora.",
			businessesAndContracts: "Negócios e Contratos",
			allContracts: "Todos os contratos",
			noBusinessesAssigned: "Sem negócios atribuídos.",
			addBusiness: "Adicionar Negócio",
			businessRequired: "Selecione um negócio.",
			contractsRequired:
				"Selecione pelo menos um contrato ou “Todos os contratos”.",
			duplicatedBusiness: "Este negócio já foi adicionado.",
		},

		vehicles: {
			brand: "Marca",
			model: "Modelo",
			year: "Ano",
			color: "Cor",
			vehicleType: "Tipo de Veículo",
			licensePlate: "Matrícula",
			capacity: "Capacidade",
			pricePerMonth: "Preço por Mês",
			typeOfContract: "Tipo de Contrato",
			contractStartDate: "Data de Início do Contrato",
			contractEndDate: "Data de Fim do Contrato",
			archived: "Veículo arquivado com sucesso.",

			// Types of contract
			contractPaid: "Pago",
			contractPaying: "A pagar",
			contractRenting: "Alugado",
			contractLeasing: "Leasing",

			// Extra
			expectedWorkingHours: "Horas de Trabalho Esperadas por Dia",
		},

		ranges: {
			today: "Hoje",
			thisMonth: "Este mês",
			lastMonth: "Último mês",
			thisYear: "Este ano",
			lastYear: "Último ano",
		},

		dashboard: {
			period: "Período",
			active: "Ativo",
			homepage: "Homepage",
			inStock: "Em Stock",
			daily: "Diário",
			monthly: "Mensal",
			newUsers: "Novos Utilizadores",
			newUsersContent: "Novos Utilizadores Conteúdo",
			uses: "Utilizações",
			androidUse: "Utilização Android",
			androidUseContent: "Utilização Android Conteúdo",
			iOSUse: "Utilização iOS",
			iOSUseContent: "Utilização iOS Conteúdo",
			webUse: "Utilização Web",
			webUseContent: "Utilização Web Conteúdo",
			contract: "Contrato",
			sosButton: "Botão de Chamada",
			chatButton: "Botão de Chat",
			usage: "Utilizadores",
			videoAppointments: "Vídeo-consultas de Psicologia",
			hotline: "Linhas de Apoio Psicológico",
			disturbances: "Perturbações Diagnosticadas",
			contractDetails: "Detalhe Contrato",
			purchased: "Contratadas",
			consumed: "Consumidas",
			balance: "Balanço",
			scheduled: "Consultas Marcadas",
			finished: "Consultas Realizadas",
			details: "Ver Detalhe",
			clicked: "N.º Vezes Clicado",
			usageApp: "Utilização App",
			calls: "Chamadas",
			chats: "Chats",
			records: "Registos de Intervenções",
			noData: "Não existe data registada no período selecionado.",
			selectPsychologist: "Selecione um(a) psicólogo(a)",
			question1: "De forma geral, está satisfeito(a) com o serviço prestado?",
			question2: "Em que medida gostou do(a) psicólogo(a) que o(a) atendeu?",
			question3: "O(a) psicólogo(a) foi pontual no seu atendimento?",
			question4: "Sente-se melhor depois da intervenção psicológica realizada?",
			question5: "No seu entender, o número de consultas está a foi adequado?",
			question6: "Em caso de necessidade, voltaria a utilizar o serviço?",
			question7: "Quanto recomendaria este serviço a um colega?",
			question8:
				"Considera que esta intervenção ajudou que se sentisse mais motivado?",
			question9:
				"Com esta intervenção, tornou-se mais fácil gerir o equilíbrio entre a vida familiar e o trabalho?",
			question10:
				"Considera importante manter o serviço de apoio psicológico na sua organização?",
			notes: "Caso queira deixar alguma sugestão, por favor, escreva abaixo",
			reviewHelp:
				'De {0} a {1}, em que {2} é "{3}" e {4} corresponde a "{5}", por favor, classifique as seguintes afirmações relativas às vídeo-consultas de Psicologia realizadas com os psicólogos da TEAM 24.',
			notReally: "muito pouco",
			little: "pouco",
			few: "moderadamente",
			many: "muito",
			alot: "extremamente",
		},

		settings: {
			pages: "Páginas",
			pagesDescription:
				"Nesta área poderá alterar o conteudo das páginas Termos & Condições e Politica de Privacidade",
			emailTemplates: "Templates de E-mails",
			emailTemplatesDescription:
				"Parametrização dos templates de emails, enviados aos utilizadores, assim como os utilizados pelo staff do Backoffice",
			vehicles: "Veículos",
			vehiclesDescription:
				"Registe a frota responsável existente e as suas características",
			addVehicle: "Adicionar veículo",
			editVehicle: "Editar veículo",
			added: "O veículo foi adicionado com sucesso.",
			edited: "O veículo foi editado com sucesso.",
			deleted: "O veículo foi eliminado com sucesso.",
			licensePlate: "Matrícula",
			licensePlateRequired:
				"A matrícula é um campo de preenchimento obrigatório.",
			nameRequired: "O nome é um campo de preenchimento obrigatório.",
			typeRequired: "O tipo é um campo de preenchimento obrigatório.",
			urlRequired: "O url é um campo de preenchimento obrigatório.",
			capacityRequired: "A capacidade é um campo de preenchimento obrigatório.",
			urlInvalid: "O url inserido não é válido.",
			vehiclePlate: "Matrícula do veículo",
			vehicleType: "Tipo de veículo",
			contractType: "Tipo de Contrato",
			capacity: "Capacidade",
			van: "Carrinha",
			bike: "Mota",
			boxes: "Caixas",
			grids: "Grade",
			gridsDescription: "Registe uma grade para ser preenchida nas rotas",
			shifts: "Turno",
			shiftsDescription: "Registe um turno para ser usado nas encomendas",
			addGrid: "Adicionar Grade",
			editGrid: "Editar Grade",
			addShift: "Adicionar Turno",
			editshift: "Editar Turno",
			contractTypes: "Tipos de contracto",
			contractTypesDescription: "Registe um tipo de contracto.",
			food: "Alimentar",
			parcel: "Parcel",
			pharmacy: "Farmácia",
			contractUrl: "Url optimizador",
			optimizerType: "Tipo de Optimizador",
			engineType: "Motor do Optimizador",
			editContractType: "Editar Tipo de Contracto",
			addContractType: "Adicionar Tipo de Contracto",
			uploadMasterData: "Importar Master Data",
			uploadMasterDataSubtitle:
				"Importe o ficheiro de Master Data, para importar clientes no sistema",
			userAlreadyExists: "Já existe um cliente com esse id",
			importedWithErrors:
				"Ficheiro Master Data importado com sucesso. Alguns clientes não foram importados (ver lista de erros).",
			imported: "O ficheiro Master Data foi importado com sucesso.",
			masterData: "Master Data",
			systemConfigBanner:
				"As configurações efetuadas aqui afetam diretamente o comportamento do sistema. Clica numa opção para configurar.",
			labelTemplates: "Templates de Etiquetas",
			lastModifiedBy: "Última alteração por",
			labelTemplatesDescription:
				"Gere os templates HTML para impressão de etiquetas",
			labelTemplateAdded: "Template de etiqueta criado com sucesso.",
			labelTemplateEdited: "Template de etiqueta editado com sucesso.",
			labelTemplateDeleted: "Template de etiqueta eliminado com sucesso.",
			notificationTemplates: "Templates de Notificações",
			notificationTemplatesDescription:
				"Gere os templates de notificações enviadas aos clientes",
			geojsonZones: "Zonas GeoJSON",
			geojsonZonesDescription:
				"Gere as zonas GeoJSON globais, partilhadas por todos os contratos",
			notificationTemplateAdded: "Template de notificação criado com sucesso.",
			notificationTemplateEdited:
				"Template de notificação editado com sucesso.",
			notificationEvent: "Evento",
		},

		pages: {
			single: "Página",
			title: "Título",
			content: "Conteúdo",
			new: "Nova Página",
			isLink: "Redirecionamento",
		},

		templates: {
			single: "Template",
		},

		emails: {
			single: "E-mail",
			tags: "Tags",
			preview: "Pré-visualização",
			subject: "Assunto",
			cc: "CC",
			templates: "Templates de E-mail",
			invite: "Convidar Staff",
			edited: "Template de E-mail editado com sucesso.",
			plainText: "Plain text",
		},

		serverErrors: {
			title: "Erro de Servidor",
			subTitle: "Não é você, somos nós!",
			refresh: "Voltar à Página Anterior",
			backToDashboard: "Ir para o Dashboard",
			wentWrong: "Algo correu mal.",
			subscribeTopicError: "Erro ao subscrever o tópico.",
		},

		logs: {
			dateRange: "Date Range",
			userId: "User Id",
			url: "Url",
			token: "Token",
			codes: "Codes",
			methods: "Methods",
			sources: "Sources",
			types: "Types",
		},

		emailTemplates: {
			generalEmail: "E-mail Genérico",
			marketingEmail: "Marketing E-mail",
			accountConfirmationCode: "Confirmação de Conta Utilizador por Código",
			recoverPasswordCode: "Recuperação de Password por Código",
			accountConfirmationLink: "Confirmação de Conta Utilizador por Link",
			recoverPasswordLink: "Recuperação de Password por Link",
			reservationEmail: "E-mail de Confirmação de Reserva",
			staffAccountConfirmation: "Confirmação de Conta de Acesso ao BO",
			staffRecoverPassword: "Recuperação de Password de Acesso ao BO",
			changeEmailCode: "Alteração de E-mail (Código)",
			changeEmailLink: "Alteração de E-mail (Link)",
		},

		businesses: {
			business: "Cliente",
			new: "Novo Cliente",
			header: "Cliente",
			plural: "Clientes",
			info: "Geral",
			deleted: "Eliminar Cliente",
			fullInfo: "Informação do Cliente",
			schedule: "Horário",
			settings: "Definições",
			financial: "Financeiro",
			addressLine1: "Endereço 1",
			addressLine2: "Endereço 2",
			location: "Localização",
			businessInformation: "Informação do Cliente",
			vatNumber: "NIF",
			invoiceName: "Nome do Cliente",
			iban: "IBAN",
			bic: "BIC",
			emptyVat: "O campo NIF é de preenchimento obrigatório.",
			invalidVat: "O NIF introduzido não é válido.",
			invalidName: "O campo nome é de preenchimento obrigatório.",
			invalidOwnerName:
				"O campo nome do proprietário é de preenchimento obrigatório.",
			invalidOwnerEmail:
				"O campo e-mail do proprietário é de preenchimento obrigatório.",
			emptyCountry: "O campo país é de preenchimento obrigatório.",
			emptyState: "O campo distrito é de preenchimento obrigatório.",
			ownerPhone: "Telefone do Proprietário",
			emptyOwnerNumber:
				"O campo telefone do proprietário é de preenchimento obrigatório.",
			approved: "Aprovado",
			approve: "Aprovar",
			added: "O cliente foi criado com sucesso.",
			edited: "O cliente foi editado com sucesso.",
			removed: "O cliente foi apagado com sucesso.",
			categories: "Categorias",
			minPriceRange: "Valor Intervalo Mínimo",
			maxPriceRange: "Valor Intervalo Máximo",
			wallet: "Carteira",
			emptyAddress: "O campo endereço é de preenchimento obrigatório.",
			invalidMaxRange:
				"O valor de intervalo máximo não pode ser inferior ao valor mínimo.",
			balance: "Saldo",
			allTransactions: "Todas as transações",
			monthBalance: "Saldo Mensal",
			totalAccumulated: "Saldo Acumulado",
			transactions: "Transações",
			receiptValue: "Valor do Recibo",
			netBalance: "Valor Líquido Recebido",
			total: "Total",
			user: "Colaborador",
			contracts: "Contratos",
			typeContract: "Tipo",
			descriptionContract: "Descrição",
			addContract: "Adicionar contrato",
			editContract: "Editar contrato",
			contractAdded: "O contrato foi criado com sucesso.",
			contractEdited: "O contrato foi editado com sucesso.",
			contractRemoved: "O contrato foi apagado com sucesso.",
			startDateRequired:
				"A data inicial do contrato é um campo de preenchimento obrigatório.",
			endDateRequired:
				"A data final do contrato é um campo de preenchimento obrigatório.",
			valueRequired:
				"O número de consultas é um campo de preenchimento obrigatório.",
			datesIntervalInvalid: "O intervalo de datas é inválido.",
			notDeliveredReasons: "Motivos de Não Entrega",
			notDeliveredReasonsHelper:
				"Isto irá sobrescrever os motivos originais de não entrega",
			internalReason: "Motivo Interno",
			externalCode: "Código Externo",
			internalCode: "Código Interno",
			reasonText: "Motivo do Cliente",
			addReason: "Adicionar Motivo",
			notDeliveredReasonsMissingFields:
				"Motivos de não entrega têm campos obrigatórios em falta.",
			duplicateInternalCode: "Código interno duplicado.",
			notDeliveredReasonsMissingLanguage:
				"Motivos de não entrega têm de ter no mínimo uma língua comum preenchida.",

			// Uniform api calls strings
			apiCallSetup: "Configuração de Chamadas API",
			apiCallSetupHelper:
				"Configure as chamadas de API externas para este negócio",
			addApiCall: "Adicionar Chamada API",
			apiCallName: "Nome",
			apiCallUrl: "URL do Endpoint",
			apiCallMethod: "Método HTTP",
			apiCallAuthMethod: "Autenticação",
			apiCallAuthNone: "Nenhuma",
			apiCallAuthApiKey: "Chave de API",
			apiCallAuthBearer: "Bearer Token",
			apiCallAuthBasic: "Autenticação Básica",
			apiCallHeaderName: "Nome do Header",
			apiCallApiKey: "Chave de API",
			apiCallBearerToken: "Bearer Token",
			apiCallUsername: "Utilizador",
			apiCallPassword: "Palavra-passe",
			apiCallBodySchema: "Esquema do Body (JSON)",
			apiCallHelpTitle: "Ajuda — Chamadas API",
			apiCallHelpUrlLabel: "URL",
			apiCallHelpUrlDesc:
				"O endereço completo do endpoint da API externa a ser chamada.",
			apiCallHelpMethodLabel: "Método HTTP",
			apiCallHelpMethodDesc:
				"O método HTTP a usar na chamada (GET, POST, PUT, PATCH, DELETE).",
			apiCallHelpAuthLabel: "Autenticação",
			apiCallHelpAuthDesc:
				"Selecione o método de autenticação e preencha os campos correspondentes. Opções: Nenhuma, Chave de API (header personalizado), Bearer Token (Authorization: Bearer …) e Autenticação Básica (utilizador + palavra-passe).",
			apiCallHelpBodySchemaLabel: "Esquema do Body",
			apiCallHelpBodySchemaDesc:
				"Define a estrutura JSON do corpo do pedido enviado à API externa. Use {{campo}} para variáveis dinâmicas substituídas em tempo de execução. Ex.: { orderId: {{orderId}}, status: {{status}} }",
			apiCallInvalidJson: "O esquema do body contém JSON inválido.",
			apiCallNameRequired: "O nome da chamada API é obrigatório.",
			apiCallUrlRequired: "O URL da chamada API é obrigatório.",
			apiCallTrigger: "Quando",
			apiCallTriggerPlaceholder: "Selecionar gatilho",
			apiCallTriggerOnRouteStart: "Início de rota (em trânsito)",
			templates: "Etiquetas",
			labelName: "Nome",
			noLabels: "Sem templates de etiquetas configurados.",
			labelActive: "Ativo",
			labelInactive: "Inativo",
			labelNew: "Nova Etiqueta",
			labelEdit: "Editar Etiqueta",
			labelTemplate: "Template HTML",
			labelPreview: "Pré-visualização",
			labelVariables: "Variáveis",
			labelNameRequired: "O nome da etiqueta é obrigatório.",
			labelTemplateRequired: "O HTML da etiqueta é obrigatório.",
			labelDeleteActiveError: "Não é possível eliminar uma etiqueta ativa.",
			labelDeleteConfirm: "Eliminar etiqueta",
			labelDeleteConfirmDesc:
				"Tem a certeza que pretende eliminar esta etiqueta?",
			labelInvalidVars: "Variáveis inválidas na etiqueta",
			labelAvailableVars: "Variáveis disponíveis",
			labelAIAssistant: "Assistente IA",
			labelAIPlaceholder:
				'Descreve o que queres alterar na etiqueta... (ex: "Adiciona o nome do cliente a negrito" ou "Muda a cor do título para azul")',
			labelAIGenerate: "Gerar",
			labelAIGenerating: "A gerar...",
			labelAIDiffBefore: "Antes",
			labelAIDiffAfter: "Depois",
			notificationsTab: "Notificações",
			notificationsDescription:
				"Associa templates de notificação por tipo de evento.",
			finishedOptimizedRoute: "Rota Otimizada",
			finishedOptimizedRouteDesc:
				"Enviada quando o otimizador finaliza a criação das rotas.",
			routeAssignedToDriver: "Rota Associada a Motorista",
			routeAssignedToDriverDesc:
				"Enviada ao motorista quando uma rota lhe é atribuída.",
			notificationTemplateTitle: "Título",
			notificationTemplateBody: "Corpo",
			notificationTemplateNameRequired:
				"O nome do template de notificação é obrigatório.",
			notificationTemplateContentRequired:
				"O template de notificação necessita de pelo menos título ou corpo numa língua.",
			notificationTestSent: "Notificação de teste enviada com sucesso.",
			notificationTestBtn: "Testar",
		},

		tenants: {
			tenant: "Tenant",
			tenants: "Tenants",
			new: "Novo Tenant",
			edit: "Editar Tenant",
			domain: "Domínio",
			authMethods: "Métodos de Autenticação",
			database: "Base de Dados",
			contactName: "Nome do Contacto",
			contactEmail: "Email do Contacto",
			contactPhone: "Telefone do Contacto",
			primaryColor: "Cor Primária",
			secondaryColor: "Cor Secundária",
			notes: "Notas",
			created: "Tenant criado com sucesso.",
			edited: "Tenant atualizado com sucesso.",
			activated: "Tenant ativado com sucesso.",
			deactivated: "Tenant desativado com sucesso.",
			deleted: "Tenant eliminado com sucesso.",
			nameRequired: "O nome do tenant é obrigatório.",
			authMethodsRequired: "Selecione pelo menos um método de autenticação.",
		},

		contracts: {
			name: "Contrato",
			business: "Cliente",
			new: "Novo Contrato",
			type: "Tipo de Contrato",
			parcel: "Parcel",
			food: "Alimentar",
			startDate: "Data de Início",
			endDate: "Date de Fim",
			baseLocation: "Localização Base",
			searchAddress: "Procurar Morada",
			startPostcode: "Início de Intervalo de Código Postal",
			endPostcode: "Fim de Intervalo de Código Postal",
			invalidWorkAreaInterval: "O último intervalo inserido não é válido.",
			workAreas: "Áreas de Trabalho",
			geojsonZones: "Zonas GeoJSON",
			geojsonDeliveryZonesTitle: "Zonas de entrega (validação)",
			geojsonDeliveryZonesPlaceholder: "Selecionar zonas para validação",
			geojsonLibraryTitle: "GeoJSONs disponíveis",
			geojsonNoAvailable: "Nenhum GeoJSON criado para este contrato.",
			geojsonInUse: "em uso",
			geojsonAddZone: "Adicionar zona GeoJSON",
			geojsonZoneName: "Nome da zona",
			geojsonBuffer: "Margem erro (km)",
			geojsonPaste: "Colar",
			geojsonUpload: "Carregar ficheiro",
			geojsonDraw: "Desenhar",
			geojsonPastePlaceholder:
				"Cole aqui o GeoJSON (FeatureCollection, Feature ou geometria)",
			geojsonUploadHint:
				"Arraste ou clique para carregar um ficheiro .geojson/.json",
			geojsonDrawHint: "Clique no mapa para desenhar o polígono.",
			geojsonRedraw: "Limpar / desenhar de novo",
			geojsonPreview: "Pré-visualização",
			geojsonCreate: "Criar zona",
			geojsonCreated: "Zona GeoJSON criada.",
			geojsonInvalid: "GeoJSON inválido. Forneça um polígono válido.",
			geojsonNameRequired: "Indique um nome para a zona.",
			geojsonNoZones: "Nenhuma zona atribuída a este contrato.",
			geojsonSelectExisting: "Adicionar zona existente",
			geojsonRemove: "Remover",
			geojsonDeleteTitle: "Eliminar zona GeoJSON",
			geojsonDeleteMessage:
				'Tem a certeza que pretende eliminar a zona "{name}"? Esta ação não pode ser revertida.',
			geojsonDeleteInUseWarning:
				"Atenção: esta zona está a ser usada na validação de entregas. Ao eliminá-la será também removida das zonas de entrega.",
			geojsonDeleteNotInUse:
				"Esta zona não está a ser usada em nenhuma validação de entregas.",
			geojsonContractZonesTitle: "Zonas do contrato",
			geojsonZoneDescription: "Descrição",
			geojsonGlobal: "global",
			geojsonEdit: "Editar",
			geojsonEditZone: "Editar zona GeoJSON",
			geojsonSave: "Guardar alterações",
			geojsonUpdated: "Zona GeoJSON atualizada.",
			geojsonModes: {
				deliveryArea: "Área de entrega",
				onlyVan: "Apenas carrinha",
				onlyBike: "Apenas mota",
			},
			geojsonShowOnMap: "Mostrar no mapa",
			geojsonHideFromMap: "Ocultar do mapa",
			geojsonModesLegend: "O que significa cada modo:",
			geojsonModesHelp: {
				deliveryArea:
					"Delimita onde o contrato entrega. Uma encomenda fora de todas as áreas de entrega é marcada com erro de morada para revisão. Sem áreas definidas, qualquer morada é aceite.",
				onlyVan:
					'Encomendas dentro desta zona são marcadas como "apenas carrinha" na importação e não são atribuídas a motas.',
				onlyBike:
					'Encomendas dentro desta zona são marcadas como "apenas mota" na importação — usado para zonas onde a carrinha não chega ou não pode estacionar.',
			},
			lots: "Lotes",
			lotName: "Nome do Lote",
			lotsPlaceholder: "NomeLote1, NomeLote2, NomeLote3",
			attachments: "Anexos",
			noData: "Ainda não foram adicionados anexos.",
			startDateMandatory:
				"O campo da data inícial do contrato é de preenchimento obrigatório.",
			endDateMandatory:
				"O campo da data final do contrato é de preenchimento obrigatório.",
			typeMandatory:
				"O campo do tipo de contrato é de preenchimento obrigatório.",
			addAttachment: "Adicionar Anexo",
			editAttachment: "Editar Anexo",
			attachment: "Anexo",
			attachmentMandatory: "É necessário selecionar um ficheiro para o anexar.",
			descriptionMandatory: "O campo descrição é de preenchimento obrigatório.",
			document: "Documento",
			horeca: "Horeca",
			baseLocationAddressMandatory:
				"A morada de localização base é obrigatória.",
			baseLocationAddress: "Morada da Localização Base",
			warehouseId: "ID Armazém",
			optimizerParams: "Parâmetros do Optimizador",
			preProcessingParams: "Parâmetros de Pré-Processamento",
			preProcessingNucleoidDistance: "Distância Nucleóide",
			preProcessingMaxVanStopsPerHour: "Máx. Paragens por Hora",
			preProcessingVicinityDistance: "Distância de Proximidade",
			preProcessingStreetPriority: "Prioridade de Rua",
			preProcessingStreetPriorityNone: "Nenhuma (sem mapa de ruas)",
			preProcessingStreetPriorityRank: "Classificação de rua (rank)",
			preProcessingStreetPriorityScore: "Pontuação de rua (score)",
			preProcessingStreetPriorityHelper:
				"Nenhuma (sem mapa de ruas): a carrinha é atribuída apenas por vicinidade de outras carrinhas e por agrupamentos de proximidade (DBSCAN) — não há reconhecimento de ruas importantes para este contrato. Usa quando não existe mapa de ruas relevante para a área deste contrato.\n\nClassificação (rank): a carrinha é atribuída a ruas conhecidas como importantes, começando pelas de classificação mais alta (número mais baixo = mais importante). Quando o limite de paragens por hora obriga a escolher entre ruas concorrentes, as de classificação mais alta ganham. Paragens próximas dessas ruas também são promovidas; o que sobrar segue para agrupamentos de proximidade (DBSCAN).\n\nPontuação (score): igual à Classificação, mas ordena as ruas por pontuação — da mais alta para a mais baixa — em vez de por número de classificação.",
			functionalities: "Funcionalidades",
			allowCheckOut: "Checkout",
			allowCheckOutHelper:
				"Permitir que os motoristas façam checkout das encomendas na aplicação móvel com um scanner de código de barras",
			splitOrdersBetweenDrivers: "Dividir Encomendas entre Motoristas",
			sms: "SMS",
			onTransitSms: "SMS em Trânsito",
			onTransitSmsHelper:
				"Envia SMS automático ao cliente quando a encomenda entrar em trânsito",
			scannerEmail: "Email Scanner",
			templateVariablesLegend:
				"Use as seguintes variáveis para inserir valores dinamicamente no template",
			templateVariablesFrom: "Inicio slot entrega",
			templateVariablesTo: "Fim slot entrega",
			templateVariablesClientName: "Nome do cliente",
			templateVariablesOrderId: "ID da encomenda",
			templateVariablesBusinessName: "Nome do cliente",
			templateVariablesTotalBoxes: "N.º total de caixas",
			smsTestMode: "SMS Test Mode",
			smsTestModeHelper:
				"Ativa o modo de teste de SMS - as mensagens só serão enviadas para números definidos na lista de teste",
			serviceTime: "Tempos de Serviço",
			useAddress: "Usar Morada para Navegação",
			useAddressHelper:
				"Usa a morada do cliente para navegação em vez das coordenadas GPS",
			getDeliveryOptions: "Foto e opções de entrega obrigatórias",
			getDeliveryOptionsHelper:
				"Torna obrigatório tirar foto e selecionar opções de entrega ao finalizar uma encomenda",
			beforeDeliverySms: "SMS Antes da Entrega",
			beforeDeliverySmsHelper:
				"Envia SMS automático ao cliente quando a encomenda anterior for realizada",
			requiredSignature: "Assinatura Obrigatória",
			requiredSignatureHelper:
				"Requer assinatura do cliente para completar a entrega",
			invalidBagSize: "O tamanho do saco é inválido.",
			invalidOutOfFormatSize: "O tamanho do fora de formato é inválido.",
			showUntreatedBoxes: "Mostrar Caixas Não Tratadas",
			showUntreatedBoxesHelper:
				"Desativar isto irá ocultar caixas não tratadas na aplicação móvel",
			separateUntreated: "Separar Não Tratados",
			separateUntreatedHelper:
				"Quando ativado, após a agregação as encomendas não tratadas são movidas para uma rota própria do tipo não roteado, com uma única caixa fictícia partilhada",
			cancelUntreated: "Cancelar Não Tratados",
			cancelUntreatedHelper:
				"Quando ativado, após a agregação as encomendas não tratadas são automaticamente canceladas.",
			mergeBikeRoutes: "Juntar Rotas de Mota",
			mergeBikeRoutesHelper:
				"Ao terminar a agregação, junta as rotas de mota com o mesmo ponto de recolha e perto umas das outras, até à capacidade de cada mota, e atribui a mota a cada rota.",
			bikeMergeMinTimeSaved: "Poupança mínima para juntar rotas do armazém",
			bikeMergeMinTimeSavedHelper:
				"Duas rotas de mota que saem do armazém só se juntam numa viagem se isso poupar pelo menos esta percentagem de tempo à mota. Não se aplica às motas que vão buscar caixas a uma carrinha.",
			bikeMergeMinTimeSavedExample:
				"Com {percent}%, duas viagens de 30 min juntam-se se a viagem junta durar até {minutes} min.",
			bikeMergeMinTimeSavedNever:
				"Com 100%, as rotas de mota do armazém nunca se juntam.",
			bikeMergeMinTimeSavedRecommended:
				"Quanto mais alto, menos rotas se juntam. Recomendado: 20%.",
			fleetEngine: "Fleet Engine",
			fleetEngineHelper: "Quando ativado, o Google Fleet Engine será usado",
			bundles: "Agrupar Encomendas",
			useBundlesHelper:
				"Quando ativado, encomendas para o mesmo cliente serão agrupadas",
			externalDelivery: "Entrega Externa",
			externalDeliveryHelper:
				"Configure os parceiros de entrega externa para este contrato",
			externalDeliveryActive: "Ativo",
			externalDeliveryWarehousePhone: "Telefone do Armazém",
			externalDeliveryWarehouseName: "Nome do Armazém",
			externalDeliveryWarehouseAddress: "Morada do Armazém (opcional)",
			externalDeliveryWarehouseAddressHelper:
				"Quando preenchida, esta morada substitui a morada e coordenadas do contrato como local de recolha nas entregas Uber. As coordenadas são preenchidas automaticamente a partir da morada.",
			externalDeliveryWarehouseShowMap: "Ver mapa",
			externalDeliveryWarehouseHideMap: "Ocultar mapa",
			externalDeliveryStoreId: "ID da Loja",
			externalDeliveryBarcodeType: "Tipo de Código de Barras",
			externalDeliveryAcceptedPhoneTypes: "Tipos de Telefone Aceites",
			externalDeliveryAcceptedPhoneTypesHelper:
				"Só as encomendas com um destes tipos de telefone são elegíveis para entrega externa.",
			externalDeliveryAcceptedPhoneTypesRequired:
				"Selecione pelo menos um tipo de telefone aceite.",
			externalDeliveryPhoneTypeMobile: "Telemóvel",
			externalDeliveryPhoneTypeLandline: "Telefone fixo",
			externalDeliveryPhoneTypeNone: "Sem telefone",
			externalDeliverySmsTemplate: "Template SMS",
			externalDeliveryPickupNotes: "Notas de Recolha",
			externalDeliveryTestMode: "Modo de Teste",
			externalDeliveryTestModeHelper:
				"Quando ativado, o estafeta será simulado por um robot que completa o processo automaticamente",
			externalDeliveryMessagingChannel: "Canal de mensagens",
			externalDeliveryMessagingChannelHelper:
				"Envia mensagens a um grupo do backoffice em momentos-chave da entrega Uber. Escolhe o grupo e os eventos a notificar.",
			externalDeliveryMessagingChannelGroup: "Grupo",
			externalDeliveryMessagingChannelGroupPlaceholder: "Selecionar grupo",
			externalDeliveryMessagingChannelEvents: "Eventos a notificar",
			externalDeliveryEventEnRoutePickup: "A caminho da recolha",
			externalDeliveryEventArrivingPickup: "A chegar à recolha",
			externalDeliveryEventPickupComplete: "Recolha efetuada",
			externalDeliveryEventAllDeliveriesDone: "Todas as entregas concluídas",
			externalDeliveryEventPartialReturn: "Em devolução com encomendas",
			externalDeliveryEventReturnsCompleted: "Devoluções concluídas",
			externalDeliveryEventRouteCancelled: "Entregas canceladas",
			externalDeliveryFieldsMandatory:
				"Todos os campos de entrega externa são obrigatórios quando um parceiro está ativo.",
			externalDeliveryInvalidPhone:
				"O número de telefone do armazém não é válido.",
			externalDeliveryStoreIdNoSpaces: "O ID da loja não pode conter espaços.",
		},

		contractTypes: {
			contractUpdated: "O tipo de contrato foi editado com sucesso.",
		},

		orders: {
			order: "Encomenda",
			preparation: "Preparação",
			concluded: "Concluídas",
			filterByStatus: "Filtrar por estado",
			filterByAttributes: "Filtrar por atributos",
			packageLabel: "Embalagem",
			withBag: "Com saco",
			boxOnly: "Só caixa",
			phoneLabel: "Telefone",
			noPhone: "Sem telefone",
			withPhone: "Com telefone",
			anyPhone: "Qualquer",
			homePhone: "Fixo",
			mobilePhone: "Telemóvel",
			paymentLabel: "Pagamento",
			withPayment: "Com pagamento",
			withoutPayment: "Sem pagamento",
			deliveryModeLabel: "Modo de Entrega",
			onlyBikeOption: "Só Bike",
			vanOption: "Van",
			anyVanOption: "Qualquer",
			forcedVanOption: "Forçada",
			promotedVanOption: "Promovida",
			geoZoneLabel: "Zona GeoJSON",
			geoZonePlaceholder: "Selecionar zona",
			geoZoneSelectContract: "Selecione um contrato para escolher uma zona",
			geoZoneAutomatic: "Automática",
			geoZoneUberLimits: "Limites Uber ({0} km)",
			registered: "Registadas",
			addressConfirmation: "Validação de Moradas",
			picking: "Seleção",
			packing: "Embalagem",
			loading: "Loading",
			on_transit: "Em trânsito",
			delivered: "Entregues",
			notDelivered: "Não Entregues",
			orderDelivered: "Entregue",
			orderNotDelivered: "Não Entregue",
			orderCancelled: "Cancelada",
			orderReturned: "Devolvida",
			cancelled: "Canceladas",
			returned: "Devolvidas",
			refunded: "Devoluções",
			processing: "Processamento",
			dispute: "Disputa",
			selectBusiness: "Selecione um cliente",
			selectContract: "Selecione um contrato",
			orderId: "ID Encomenda",
			payment: "Pagamento",
			deliveryDate: "Data Prevista",
			deliveredDate: "Data de Entrega",
			deliveredTime: "Hora de Entrega",
			clientName: "Nome Cliente",
			phoneNumber: "Telefone",
			orderAddress: "Morada",
			userAddress: "Morada de Envio",
			deliverySlot: "Slot de Entrega",
			latitude: "Latitude",
			longitude: "Longitude",
			validationDateError: "Data: A encomenda não possui data de entrega.",
			validationPostCodeError:
				"Código Postal: A encomenda não possui código postal ou não é válido.",
			validationAddressError:
				"Morada: A encomenda não possui uma morada de entrega ou necessita de validação.",
			validationCoordinatesError:
				"Coordenadas: Não foi possível adquirir as coordenadas da morada.",
			validationSlotError:
				"Slot: A encomenda não possui um slot de entrega ou o slot é inválido.",
			validationPhoneError:
				"Telefone: A encomenda não possui um número de telefone.",
			definePicking: "Avançar para Seleção",
			refresh: "Recarregar",
			edited: "A encomenda foi editada com sucesso.",
			editedPlural: "As encomendas foram editadas com sucesso.",
			imported: "Encomendas importadas com sucesso.",
			download: "Download Template",
			uploadFile: "Clique ou arraste o ficheiro para aqui",
			import: "Importar",
			upload: "Importar Encomendas",
			uploadBoxes: "Importar Caixas",
			pleaseSelectBoth: "Por favor, selecione um cliente e um contrato",
			pleaseSelectBusiness: "Por favor, selecione um cliente",
			pleaseSelectContract: "Por favor, selecione um contrato",
			pleaseSelectDate: "Por favor, selecione uma data",
			orderDate: "Data de Encomenda",
			existingOrderDate: "Data da Encomenda Existente",
			slot: "Slot de Entrega",
			status: "Estado",
			formattedOrderAddress: "Morada de Entrega Formatada",
			clientAddress: "Morada do Cliente",
			newAddress: "Nova Morada",
			importedErrors: "Encomendas não Importadas (Erros)",
			missingOrderId: "ID da Encomenda em Falta",
			duplicateOrderId: "Uma encomenda com este ID já foi importada",
			duplicateOrderIdInFile:
				"IDs de encomenda duplicados encontrados no ficheiro.",
			failedUpdate: "Falha na atualização.",
			importedWithErrors:
				"Encomendas importadas com sucesso. Algumas encomendas não foram importadas (ver lista de erros).",
			serviceType: "Tipo de Serviço",
			totalWeight: "Peso Total",
			totalVolume: "Volume Total",
			itemsQuantity: "N. Total Items",
			finalAddress: "Morada Final",
			noErrors: "A encomenda não tem qualquer erro registado.",
			orderErrors: "Erros",
			coordinates: "Coordenadas",
			defineAddress: "Definir Morada de Envio",
			normal: "Normal",
			phoneMandatory: "O campo telefone é de preenchimento obrigatório.",
			invalidPhone: "O número de telefone não é válido.",
			addressMandatory: "É necessário fornecer uma morada de entrega.",
			selectShippingAddress: "Selecione uma morada de envio ou crie uma nova.",
			bagId: "ID Saco",
			totalBoxes: "N.º Caixas",
			packaging: "Embalagem",
			packagingType: "Tipo de Embalagem",
			bag: "Saco",
			box: "Caixa",
			boxId: "ID Caixa",
			addBox: "Adicionar Caixa",
			weight: "Peso",
			fillBagFields: "Todos os campos são de preenchimento obrigatório.",
			fillOneBox: "É necessário criar, pelo menos, uma caixa.",
			boxMissingFields: "Existe(m) caixa(s) com campos por preencher.",
			classificationPreset: "Predefinido",
			classificationManual: "Manual",
			tabBags: "Sacos",
			tabOutOfFormat: "Fora de formato",
			sizeVerySmall: "Muito pequeno",
			sizeSmall: "Pequeno",
			sizeMedium: "Médio",
			sizeLarge: "Grande",
			sizeVeryLarge: "Muito grande",
			currentClassification: "Classificação atual",
			suggestedClassification: "Sugestão",
			unclassified: "Não classificada",
			classificationReadOnly:
				"A classificação só pode ser alterada enquanto a encomenda está em embalamento.",
			alreadyClassifiedTitle: "Encomenda já classificada",
			alreadyClassifiedContent:
				"Esta encomenda já tem uma classificação. Pretende substituí-la?",
			replace: "Substituir",
			bagIdMustStartWithHash: "O ID do saco tem de começar por #.",
			bulkClassificationLabel: "Classificação em massa",
			bulkClassificationShort: "Massa",
			undoBulkClassification: "Anular classificação em massa",
			reclassifyBulk: "Reclassificar",
			bulkUndoConfirm:
				"{0} encomenda(s) voltam a ficar sem classificação. Pretende continuar?",
			bulkReclassifyTitle: "Reclassificar {0} encomenda(s)",
			bulkUpdatedSuccess: "{0} encomenda(s) atualizada(s).",
			bulkMixedTitle: "Seleção inválida",
			bulkMixedDescription:
				"Só é possível anular ou reclassificar encomendas que foram classificadas em massa ao mesmo tempo.",
			bulkValidGroups: "Classificações em massa na seleção",
			bulkInvalidOrders: "Encomendas não elegíveis",
			bulkSelectOnlyGroup: "Selecionar só este grupo",
			bulkGroupOrders: "{0} encomenda(s)",
			bulkReasonNotBulk: "Não foi classificada em massa",
			bulkReasonNotPacking: "Já não está em embalamento",
			bulkReasonNotFound: "Não encontrada",
			createBox: "Criar Caixas",
			moveToPacking: "Avançar para Embalagem",
			sendBackToPacking: "Reenviar para Embalagem",
			routes: "Rotas",
			routeName: "Nome da Rota",
			routeDate: "Data da Rota",
			gradeId: "ID Grade",
			loadingOrder: "Ordem de Carregamento",
			evalyzeId: "ID Evalyze",
			routeInfo: "Dados da Rota",
			routeBoxes: "Caixas da Rota",
			position: "Posição Grade",
			gradeIdMandatory:
				"O ID da grade é um campo de preenchimento obrigatório.",
			vanMandatory: "A seleção da Matrícula é obrigatória.",
			routeEdited: "A rota foi editada com sucesso.",
			published: "Publicada",
			driver: "Condutor",
			missingMandatoryFields: "Campos obrigatórios em falta",
			addressNumber: "N.º",
			addressFloor: "Andar",
			invalidPostCode:
				"O código postal não é válido (XXXX-XXX) ou não foi inserido",
			invalidDateFormat: "O formato da data não é válido (YYYY-MM-DD)",
			invalidSlot: "O formato da slot não é válido (HH:MM)",
			invalidBagId: "O ID do saco não é válido (#1, #2 or #3)",
			savePacking: "Concluir Packing",
			aggregateBags: "Agregar Sacos",
			aggregation: "Agregação",
			inRoute: "Em Rota",
			grid: "Grade",
			line: "Linha",
			column: "Coluna",
			depth: "Profundidade",
			route: "Rota",
			readyToVan: "Preparar Van",
			readyToLoad: "Preparar Carga",
			dispatching: "Dispatching",
			moveToLoad: "Avançar para Preparar Carga",
			moveToReadyToVan: "Avançar para Preparar Van",
			moveToDispatching: "Avançar para Dispatching",
			moveToOnTransit: "Avançar para Trânsito",
			readyToDeliver: "Pronto para entrega",
			readyToDispatch: "Pronto para dispatching",
			vehicle: "Veículo",
			warehouse: "Armazém",
			stopType: "Tipo de Paragem",
			address: "Morada",
			archiveMessage: "Tem a certeza de que pretende arquivar este item?",
			archive: "Arquivar",
			outOfFormatBoxes: "Caixas fora do formato",
			outOfFormat: "Fora de Formato",
			readyBoxes: "Já em Caixa",
			duplicateBoxId: "ID de caixa já em uso",
			aggregationBoxNoId: "Sem ID",
			aggregationTemporary: "Temporária",
			aggregationFinalized: "Finalizada",
			aggregationOrdersLabel: "ENCOMENDAS",
			aggregationTreated: "tratadas",
			aggregationNoOrders: "Sem encomendas",
			aggregationBoxesTitle: "Caixas de Agregação",
			aggregationNoBoxes: "Sem caixas disponíveis",
			aggregationBoxSingular: "caixa",
			aggregationBoxPlural: "caixas",
			aggregationFinalizedLabel: "finalizadas",
			aggregationEnterBoxId: "Inserir ID da caixa...",
			aggregationFinalizeBox: "Finalizar Caixa",
			aggregationUntreatedWarning:
				"encomenda(s) não tratada(s). Finalizar mesmo assim?",
			aggregationCancel: "Cancelar",
			aggregationFinalizeConfirm: "Finalizar",
			aggregationFinalizeAll: "Finalizar Agregação",
			outOfRouteBoxes: "Caixas fora de rota",
			progress: "Progresso",
			selectDriver: "Selecionar Motorista",
			selectGrid: "Selecionar Grade",
			selectVehicle: "Selecionar Veículo",
			selectOrderStatus: "Estado da Encomenda",
			complaints: "Reclamações",
			billing: "Faturação",
			partialDelivered: "Entregue Parcialmente",
			mixedFailed: "Falha Mista",
			orderDeliveryInfo: "Informação de Entrega",
			notes: "Notas",
			images: "Imagens",
			nextStatus: "Próximo Estado",
			previousStatus: "Estado Anterior",
			staff: "Funcionário",
			orderLogs: "Logs da Encomenda",
			operationsBlock: "Bloco de Operações",
			deliveryHistory: "Histórico de Entregas",
			arrivalTime: "Tempo de Chegada",
			departureTime: "Tempo de Saída",
			estimatedTimeArrival: "Tempo estimado de chegada",
			estimatedTimeDeparture: "Tempo estimado de saída",
			boxes: "Caixas",
			noBoxes: "A encomenda ainda não tem qualquer caixa associada",
			marketPlaceCode: "Código Marketplace",
			clientId: "ID Cliente",
			notDeliveredReason: "Motivo de Não Entrega",
			orderNotInPacking: `Encomenda fora do estado "Em Embalagem"`,
			orderNotFound: "A encomenda não existe",
			pile: "Pilha",
			lot: "Lote",
			notReasonError:
				"O campo 'Motivo de Não Entrega' é de preenchimento obrigatório.",
			emptyNotesField:
				"Escolheu o motivo: 'Outro Motivo', por favor, escreva uma nota",
			validateAddress: "Validar Morada",
			warnings: "Avisos",
			gridLoadSequence: "Sequência de Carga",
			loadType: "Tipo de Sequência",
			visualGrid: "Visualização da Grade",
			tableView: "Vista de Tabela",
			gridVisualization: "Visualização da Grade (Camadas de Profundidade)",
			legend: "Legenda",
			gridLegendText:
				"Passe o cursor sobre as caixas para ver os detalhes. As caixas azuis estão carregadas, as caixas brancas são posições vazias.",
			emptyPosition: "Posição vazia",
			noLoadSequenceData: "Sem dados de sequência de carga disponíveis",
			errors: "Erros",
			noWarning: "Sem Aviso",
			noError: "Sem Erro",
			errorFindingRoute: "Erro ao encontrar a rota.",
			bundledOrders: "Encomendas Agrupadas",
			bundledOrdersStatus: "Estado das Encomendas Agrupadas",
			optimizer: "Optimizador",

			// Route4me Sync
			route4meSyncMessage:
				"Esta ação irá reescrever todas as rotas deste contrato no dia selecionado com dados do route4me, pretende avançar?",
			route4meSyncOnTransitWarnMessage:
				"Aviso! Existem encomendas em trânsito, sincronizar com o route4me irá afetar a rota atualmente em progresso e poderá causar problemas para o motorista. Deseja continuar?",
			syncRoute4me: "Sincronizar do route4me",
			syncRoute4meTooltip: "Sincronizar rotas deste contrato com o route4me",
			synced: "Rota sincronizada com sucesso",
			showOnMap: "Ver no mapa",

			// Confirmation Modal
			confirmSendToOptimizer: "Confirmar envio para otimizador",
			confirmSendToOptimizerMessage:
				"Tem a certeza que deseja enviar {0} encomenda{1} para o otimizador?",
			confirmSendToOptimizerDescription:
				"Esta ação irá processar as encomendas para criação de rotas.",
			confirmSend: "Sim, enviar",

			// Service Types
			serviceTypes: {
				delivery: "Entrega",
				collection: "Recolha",
			},

			stopTypes: {
				delivery: "Entrega",
				pickup: "Recolha",
			},

			// Address Validation
			addressValidationSuccess: "Morada validada com sucesso.",
			addressesValidationSuccess: "Moradas validadas com sucesso.",
			addressValidationError: "Erro ao validar a morada.",
			incompleteAddressTitle: "Morada incompleta",
			incompleteAddressWarning:
				"Esta morada não tem número de porta. Ao guardá-la, poderá validar automaticamente uma encomenda futura de outra casa na mesma rua. Deseja guardar mesmo assim?",
			saveAnyway: "Guardar mesmo assim",
			validateWithoutSaving: "Validar sem guardar",
			validateAndSave: "Validar e guardar",
			originalAddress: "Morada Original",
			formattedAddress: "Morada Formatada",
			validationSource: "Validação",
			validatedBySystem: "Validada pelo sistema",
			validatedByUser: "Validada pelo utilizador",
			confirmBoxCompletion: "Confirmar Conclusão da Caixa",
			warningCannotUndo: "Aviso: Esta ação não pode ser desfeita!",
			yesFinishBox: "Sim, Finalizar Caixa",
			allLots: "Todos os Lotes",

			// Bulk Lot Update
			bulkLotUpdateSuccess:
				"Lote atualizado com sucesso para as encomendas selecionadas.",

			// Change Status
			statusChangeRequirements: "Requisitos não cumpridos:",
			changeStatusTo: "Alterar estado para {0}",
			changeMultipleOrdersStatus: "Alterar {0} encomendas para estado {1}",
			ordersSelectedOf: "{0} de {1} encomendas selecionadas",
			allOrdersSameStatus: "Todas as encomendas devem ter o mesmo estado",
			multipleStatuses: "Múltiplos estados",
			noNextStatus: "Sem próximo estado disponível",
			sendToOptimizerToCreateRoutes:
				"Enviar {0} encomenda(s) para otimizador para criar rotas",
			allOrdersMustHaveBoxesOrBags:
				"Todas as encomendas devem ter caixas ou sacos atribuídos",
			allOrdersMustHaveBoxes: "Todas as encomendas devem ter caixas atribuídas",
			bagsNotAllowedInNonParcel:
				"Sacos não são permitidos em contratos não-parcel",
			statusUpdated: "Estado Atualizado",
			updateFailed: "Atualização Falhou",
			statusUpdateError: "Falha ao atualizar o estado da encomenda",
			ordersInThePastCannotBeSent:
				"Encomendas com data de entrega no passado não podem ser enviadas",
			ordersWithErrorsCannotBeSentToPicking:
				"Encomendas com erros não podem ser enviadas para picking",
			closerWarningTitle: "Slot/Turno Divergente",
			closerWarningDescription:
				"As seguintes encomendas têm um slot diferente do turno. Selecione as que pretende enviar para o otimizador.",
			closerWarningSend: "Enviar {0} encomenda(s)",
			shift: "Turno",
			externalSplitTitle: "Entrega Externa",
			externalSplitDescription:
				"{0} das {1} encomendas selecionadas são elegíveis para entrega externa. Escolha como pretende enviá-las para o otimizador.",
			externalSplitOptionSplit: "Criar rotas externas em separado",
			externalSplitOptionSplitHint:
				"Duas otimizações: primeiro as {0} elegíveis, apenas em mota, depois as restantes {1}.",
			externalSplitOptionExternalOnly: "Enviar apenas as elegíveis",
			externalSplitOptionExternalOnlyHint:
				"Otimiza as {0} elegíveis, apenas em mota. As restantes ficam em embalagem.",
			externalSplitOptionNonExternalOnly: "Enviar apenas as não elegíveis",
			externalSplitOptionNonExternalOnlyHint:
				"Otimiza as {0} restantes. As elegíveis ficam em embalagem.",
			externalSplitOptionAllInternal: "Enviar todas como não externas",
			externalSplitOptionAllInternalHint:
				"Uma única otimização com as {0} encomendas, sem tratamento especial.",
			externalSplitIneligibleTitle: "Não elegíveis ({0})",
			externalSplitExcludedNotice:
				"As encomendas não enviadas ficam em embalagem e podem ser enviadas mais tarde.",
			externalSplitEligibilityFailed:
				"Não foi possível verificar a elegibilidade para entrega externa.",
			externalSplitFutureTitle:
				"{0} encomenda(s) só podem ser atribuídas ao parceiro {1}",
			externalSplitFutureDescription:
				"As rotas são criadas agora, mas a entrega externa é no próprio dia: só ficam disponíveis para atribuição a {0}.",
			externalSplitAssignableTomorrow: "amanhã",
			externalSplitAssignableInDays: "dentro de {0} dias",
			orderInformation: "Informação da Encomenda",
			ordersToAggregate: "encomendas para agregar",
			ordersToValidate: "encomendas para validar",
			temporaryOrderPendingProcessing:
				"encomenda temporária a aguardar processamento",
			temporaryOrdersPendingProcessing:
				"encomendas temporárias a aguardar processamento",
			temporaryOrder: "Encomenda Temporária",
			temporaryOrders: "Encomendas Temporárias",
			temporaryOrdersFooter:
				"Estas encomendas estão temporariamente armazenadas e a aguardar processamento",
			treated: "Tratada",
			importOrdersSubtitle: "Importar para validação de moradas",
			importBoxesTitle: "Caixas / Sacos",
			importBoxesSubtitle: "Para encomendas em embalagem",
			downloadLabel: "Download Etiqueta",
			openOrder: "Abrir Encomenda",
			openRoute: "Abrir Rota",
			deleteOrder: "Eliminar Encomenda",
			changeLot: "Alterar Lote",
			deleteOrders: "Eliminar {0} encomenda(s)",
			actionsOnlyAddressConfirmation:
				"Alterar lote e apagar apenas disponíveis para encomendas em validação de moradas",
			confirmDeleteTitle: "Confirmar Eliminação de Encomenda(s)",
			confirmDeleteWarning: "Atenção: Esta ação não pode ser desfeita!",
			confirmDeleteBody:
				"Estás prestes a eliminar permanentemente {0} encomenda(s). Estas serão removidas do sistema completamente.",
			confirmDeleteSingleBody:
				"Estás prestes a eliminar permanentemente a encomenda {0}. Esta será removida do sistema completamente.",
			ordersToDelete: "Encomenda(s) a eliminar:",
			updateLotTitle: "Atualizar Lote em Massa",
			updateLotButton: "Atualizar {0} encomenda(s)",
			updateLotHeader: "Atualização de Lote em Massa",
			updateLotBody:
				"Estás prestes a atualizar o lote de {0} encomenda(s). Insere o novo valor do lote abaixo.",
			updateLotNewLot: "Novo Lote",
			updateLotPlaceholder: "Insere o novo valor do lote",
			updateLotSelected: "Encomendas selecionadas:",
			updateLotCurrent: "Atual:",
			selectColumns: "Selecionar colunas",
			selectAllColumns: "Todas",
			resetColumns: "Predefinição",
			columnsVisibleCount: "{0} de {1} colunas visíveis",
			columnsDragHint: "Arraste para reordenar as colunas",
			senderName: "Remetente",
		},

		routes: {
			name: "Rota",
			status: "Estado",
			type: "Tipo de Rota",
			types: {
				van: "Carrinha",
				bike: "Mota",
				unrouted: "Não Roteada",
			},
			numberOfDeliveries: "N.º Entregas",
			numberOfPickups: "N.º Levantamentos",
			allContracts: "Todos",
			contractRequiredForAction:
				'Selecione um contrato específico (não "Todos") para fazer esta ação.',
			routesSelected: "{0} Rotas Selecionadas",
			toBeImplemented: "A SER IMPLEMENTADO ({0} rotas selecionadas)",
			multipleDates: "Várias Datas",
			selectAll: "Selecionar Todas",
			selectNone: "Desselecionar Todas",
			untreatedBoxesWarning:
				"Esta encomenda não foi tratada durante a agregação e não será mostrada ao motorista.",
			someUntreatedBoxesWarning:
				"Algumas encomendas não foram tratadas durante a agregação e não serão mostradas ao motorista.",
			pleaseSelectRoute: "Por favor, selecione uma rota",
			notDeliveredReason: "Motivo de Não Entrega",
			filterByStatus: "Filtrar por Estado",
			filterByVan: "Filtrar por Carrinha",
			vanWithId: "Carrinha {0}",
			searchRoutes: "Procurar rotas...",
			multiSelectHint:
				"Esta checkbox seleciona todas. Para escolher apenas algumas, use Ctrl+clique (⌘+clique no Mac) nas linhas da tabela.",
			exportRoute: "Exportar Rota",
			exportLoadSequence: "Exportar Sequência de Carga",
			routeName: "Nome da Rota",
			progress: "Progresso",
			stops: "Paragens",
			orders: "Encomendas",
			routeNotFound: "Rota não encontrada",
			enterRouteName: "Introduzir nome da rota",
			gridUpdated: "Grade Atualizada",
			updateFailed: "Atualização Falhada",
			gridUpdateSuccess: "Grade da rota foi atualizada com sucesso",
			gridUpdateError: "Falha ao atualizar a grade da rota",
			vehicleUpdated: "Veículo Atualizado",
			vehicleUpdateSuccess: "Veículo da rota foi atualizado com sucesso",
			vehicleUpdateError: "Falha ao atualizar o veículo da rota",
			bikeCapacityWarningTitle: "Mota com capacidade insuficiente",
			bikeCapacityWarning:
				'Esta rota tem {boxes} caixas e a mota "{vehicle}" só leva {capacity}. Queres atribuí-la na mesma?',
			bikeCapacityWarningConfirm: "Atribuir mesmo assim",
			bikeCapacityWarningCancel: "Cancelar",
			bikeCapacityOption: "{capacity} caixas",
			driverUpdated: "Motorista Atualizado",
			driverUpdateSuccess: "Motorista da rota foi atualizado com sucesso",
			driverUpdateError: "Falha ao atualizar o motorista da rota",
			routeNameUpdated: "Nome da Rota Atualizado",
			routeNameUpdateSuccess: "Nome da rota foi atualizado com sucesso",
			routeNameUpdateError: "Falha ao atualizar o nome da rota",
			externalDelivery: "Entrega Externa",
			selectExternalProvider: "Selecionar Fornecedor",
			assignToExternal: "Atribuir a Fornecedor Externo",
			externalDeliveryConfirm:
				"Tem a certeza que quer atribuir estas encomendas a um motorista externo ({0})?",
			externalDeliverySuccess:
				"Encomendas atribuídas ao fornecedor externo com sucesso",
			externalDeliveryError:
				"Falha ao atribuir encomendas ao fornecedor externo",
			externalEligibilityColumn: "Externa",
			pickupColumn: "Recolha",
			pickupWarehouse: "Armazém",
			pickupVanTooltip: "Esta recolha é na paragem {0} da carrinha {1}.",
			pickupVanTooltipNoName: "Esta recolha é na paragem {0} da carrinha.",
			externalEligibleTooltip:
				"Esta rota pode ser atribuída a entrega externa.",
			externalNotEligibleTooltip:
				"Esta rota não pode ser atribuída a entrega externa.",
			externalWarningTooltip:
				"Atribuível, mas algumas encomendas têm telefone fixo ou sem número (será usado o número do armazém).",
			externalAssignedTooltip: "Esta rota já está atribuída a entrega externa.",
			externalDeliveryPendingBatches:
				"Existem batches ainda a serem processados pelo parceiro externo. Aguarde até estarem concluídos antes de pedir um novo batch.",
			externalDeliveryMultiSummary:
				"{0} rota(s) e um total de {1} encomenda(s) serão atribuídas.",
			externalDeliveryNotEligible:
				"A rota tem de estar em dispatching, hoje, do tipo bike e sem fornecedor externo atribuído.",
			externalDeliveryMultiNotEligible:
				"Todas as rotas selecionadas têm de estar em dispatching, hoje, do tipo bike e sem fornecedor externo atribuído.",
			externalDeliveryPartialSuccess:
				"Atribuição parcial: {0} rota(s) falharam e podem ser retomadas.",
			externalDeliveryFailedTitle: "Rotas com Falha",
			externalDeliveryFailedDescription:
				"As seguintes rotas não puderam ser atribuídas ao fornecedor externo:",
			externalDeliveryCount: "Entregas Externas",
			ordersWillBeSent:
				"encomendas serão enviadas (encomendas não tratadas excluídas)",
			allOrdersUntreated:
				"Todas as encomendas estão não tratadas e não podem ser enviadas para um fornecedor externo.",
			externalDeliveryPartner: "Parceiro",
			externalDeliveryStatus: "Estado",
			externalDeliveryCourier: "Estafeta",
			externalDeliveryPickupEta: "ETA Recolha",
			externalDeliveryDropoffEta: "ETA Entrega",
			externalDeliveryTracking: "Rastreio",
			externalDeliveryReturnPincode: "PIN de Devolução",
			externalDeliveryBarcode: "Código de Barras",
			externalDeliveryManifestItems: "Itens do Manifesto",
			externalDeliveryAssignedAt: "Atribuído em",
			externalDeliveryBatchingStatus: "Estado do Batch",
			externalDeliveryBatches: "Batches Externos",
			externalDeliveryStatusFlow: "Histórico de Estados",
			deliveryProgress: "Progresso da Entrega",
			deliveryProgressInternal: "Entrega Interna",
			deliveryProgressExternal: "Entrega Externa",
			showAllStatuses: "Mostrar todos os estados",
			showKeyStatuses: "Mostrar apenas estados principais",
			deliveryNoLocationData: "Sem dados de localização para mostrar",
			deliveryNoStatusEvents: "Sem eventos de estado para mostrar",
			externalDeliveryStatusPending: "Pendente",
			externalDeliveryStatusAssigned: "Atribuído",
			externalDeliveryStatusEnRoutePickup: "A caminho da Recolha",
			externalDeliveryStatusArrivingPickup: "A chegar à Recolha",
			externalDeliveryStatusPickupComplete: "Recolha Concluída",
			externalDeliveryStatusOutForDelivery: "Em Entrega",
			externalDeliveryStatusArrivingDropoff: "A chegar à Entrega",
			externalDeliveryStatusDelivered: "Entregue",
			externalDeliveryStatusReturning: "A Devolver",
			externalDeliveryStatusNotDelivered: "Não Entregue",
			externalDeliveryStatusCancelled: "Cancelado",
			externalReturnsReturning: "A devolver",
			externalReturnsReturned: "Devolvida",
			externalReturnsStatus: "Devolução",
			externalBatchProgress: "Progresso",
			externalBatchProgressFailed: "Falhadas",
			externalBatchProgressPending: "Por concluir",
			externalReturnsProgress: "Devoluções",
			externalReturnsWarning:
				"{0} não entregue(s) e não devolvida(s) — verificar",
			externalReturnsNoReturn: "Sem devolução",
			externalReturnsReturnFailed: "Devolução falhada",
			externalReturnsFailedAt: "Falhou às",
			externalBatchingProcessing: "A Processar",
			externalBatchingPartnerAccepted: "Parceiro Aceitou",
			externalBatchingSearching: "A procurar...",
			externalBatchingInProgress: "Em Progresso",
			externalBatchingCompleted: "Concluído",
			externalBatchesTitle: "Batches Externos",
			externalBatchesEmpty: "Sem batches externos para os filtros selecionados",
			externalBatchesOrders: "encomendas",
			externalBatchesOrder: "encomenda",
			externalBatchesVehicle: "Veículo",
			externalBatchesPhone: "Telefone",
			externalBatchesRoute: "Rota",
			updateError: "Ocorreu um erro ao atualizar",
			routeNumber: "Número da Rota",
			routeProgress: "Progresso da Rota",
			delivered: "Entregues",
			deliveredCollection: "Recolhido",
			notDelivered: "Não Entregues",
			onTransit: "Em Trânsito",
			finished: "Concluída",
			addresses: "Moradas",
			routeMap: "Mapa da Rota",
			routesMap: "Mapa das Rotas",
			colorByRoute: "Por Rota",
			colorByRouteType: "Por Tipo",
			colorByContract: "Por Contrato",
			showAllOnMap: "Mostrar tudo",
			recenter: "Recentrar",
			attachments: "Anexos",
			depot: "Armazém",
			order: "Encomenda",
			eta: "ETA",
			etd: "ETD",
			service: "Serviço",
			slot: "Slot",
			stopNumber: "Paragem",
			stopType: "Tipo de Paragem",
			currentStatus: "Estado Atual",
			deliverySlot: "Slot de Entrega",
			changeStatus: "Alterar Estado",
			externalOverrideTitle: "Correção de Estado (Entrega Externa)",
			externalOverrideWarning:
				"Último recurso. Use apenas para corrigir o estado interno quando o parceiro externo reportou um estado final errado. Os dados da entrega externa são mantidos. A alteração fica registada com o seu nome, data e notas.",
			externalOverrideSubmit: "Aplicar Correção",
			externalOverrideSuccess: "Estado da encomenda corrigido para {0}",
			externalOverrideNotesRequired:
				"As notas são obrigatórias para registar o motivo da correção",
			newStatus: "Novo Estado",
			deliveredDateTime: "Data e Hora de Entrega",
			arrivalTime: "Hora de Chegada",
			departureTime: "Hora de Saída",
			uploadFile: "Carregar Ficheiro",
			updateStatus: "Atualizar Estado",
			statusUpdated: "Estado Atualizado",
			statusUpdateSuccess: "Estado da rota alterado para {0}",
			statusUpdateSuccessMultiple: "{0} rotas com estado alterado para {1}",
			statusUpdateError: "Falha ao atualizar o estado da rota",
			provideNotDeliveryReason: "Por favor forneça um motivo de não entrega",
			notesRequiredForOther:
				"Campo de notas é obrigatório quando o motivo é 'Outro'",
			orderIdNotFound: "ID da encomenda não encontrada",
			statusChangeRequirements: "Requisitos não cumpridos:",
			changeStatusTo: "Alterar estado para {0}",
			changeMultipleRoutesStatus: "Alterar {0} rotas para estado {1}",
			allRoutesSameStatus: "Todas as rotas devem ter o mesmo estado",
			mustHaveAddresses: "Deve ter pelo menos uma morada",
			addressesMissingLocation: "{0} morada(s) sem dados de localização",
			vehicleMustBeAssigned: "Veículo deve ser atribuído",
			gridMustBeAssigned: "Grade deve ser atribuída para rotas de carrinha",
			driverMustBeAssigned: "Motorista deve ser atribuído",
			mustHaveDeliveryAddresses: "Deve ter moradas de entrega",
			notScheduledForToday: "Não agendado para hoje",
			alreadyOnTransit: "Já em trânsito - estado final",
			transitWarningMessage:
				"O motorista deve colocar a rota em trânsito através da aplicação. Fazê-lo no backoffice deve ser apenas um último recurso. Tem a certeza que pretende continuar?",
			exportRouteSuccess: 'Rota "{0}" exportada com sucesso.',
			noLoadSequenceData:
				"Sem dados de sequência de carga disponíveis para esta rota.",
			selectDriver: "Selecione um motorista",
			selectVehicle: "Selecione um veículo",
			selectGrid: "Selecione uma grade",
			started: "Iniciado",
			statusChangesOnlyOnTransit:
				"Alterações de estado estão disponíveis apenas para encomendas em estado 'Em Trânsito' ou posterior.",
			statusChangesBlockedDueToRestarted:
				"As alterações de estado estão bloqueadas porque a encomenda já está em um novo dia.",
			outOfFormatBoxes: "Caixas Fora de Formato",
			outOfFormat: "Fora de Formato",
			duplicateBoxId: "ID de caixa já em uso",
			aggregationBoxNoId: "Sem ID",
			aggregationTemporary: "Temporária",
			aggregationFinalized: "Finalizada",
			aggregationOrdersLabel: "ENCOMENDAS",
			aggregationTreated: "tratadas",
			aggregationNoOrders: "Sem encomendas",
			aggregationBoxesTitle: "Caixas de Agregação",
			aggregationNoBoxes: "Sem caixas disponíveis",
			aggregationBoxSingular: "caixa",
			aggregationBoxPlural: "caixas",
			aggregationFinalizedLabel: "finalizadas",
			aggregationEnterBoxId: "Inserir ID da caixa...",
			aggregationFinalizeBox: "Finalizar Caixa",
			aggregationUntreatedWarning:
				"encomenda(s) não tratada(s). Finalizar mesmo assim?",
			aggregationCancel: "Cancelar",
			aggregationFinalizeConfirm: "Finalizar",
			aggregationFinalizeAll: "Finalizar Agregação",
			bikePickup: "Recolher Caixa da Carrinha",
			startTime: "Hora de Início",
			endTime: "Hora de Fim",
			routeDuration: "Duração",

			// Address/Order Form Errors
			validationError: "Erro de Validação",
			fixFormErrors:
				"Por favor, corrija os erros no formulário antes de submeter.",
			arrivalTimeRequiredWhenDepartureTimeSet:
				"Hora de chegada é obrigatória quando a hora de saída está definida.",
			departureTimeRequiredWhenArrivalTimeSet:
				"Hora de saída é obrigatória quando a hora de chegada está definida.",
			arrivalTimeCannotBeAfterDepartureTime:
				"Hora de chegada não pode ser depois da hora de saída.",

			// Fleet Tracking
			fleetTracking: {
				speed: "Velocidade",
				direction: "Direção",
				remainingStops: "Paragens restantes",
				remainingDistance: "Distância restante",
				remainingDuration: "Tempo restante",
				lastUpdate: "Última atualização",
				errorTracking: "Erro ao rastrear localização do veículo",
				errorInitializing: "Falha ao inicializar rastreamento",
				deliveryStop: "Paragem de Entrega",
				orders: "encomenda(s)",
				noTrackingId: "Sem ID de rastreamento disponível",
				liveTracking: "Tracking",
				standardMap: "Mapa Normal",
				fullscreen: "Ecrã Inteiro",
				legendSuccess: "Entregue",
				legendFailed: "Não Entregue",
				legendInTransit: "Em Trânsito",
				legendEnroute: "A caminho",
				legendArrived: "Chegou ao destino",
				legendOutcomeLocation: "Local de entrega/não entrega",
				legendMarkers: "Marcadores",
				legendRoutes: "Percurso",
				legendRouteCompleted: "Percurso concluído",
				legendRouteActive: "Percurso ativo",
				legendRouteRemaining: "Percurso restante",
				legend: "Legenda",
			},

			// Address Details Modal
			partialUpdate: "Atualização Parcial",
			ordersUpdatedPartially:
				"{0} de {1} encomendas atualizadas com sucesso. {2} encomenda(s) falharam a atualizar.",
			ordersUpdatedSuccessfully: "{0} encomendas atualizadas com sucesso",
			boxes: "Caixas",
			deliveryLocation: "Local de Entrega",
			plannedLocation: "Local Planeado",
			actualDeliveryLocation: "Local de Entrega Real",
			selectDateAndTime: "Selecionar data e hora",
			selectTime: "Selecionar hora",
			enterNotes: "Introduzir notas...",
			uploadLimit: "Limite de Upload",
			uploadLimitDescription: "Só pode carregar até 2 ficheiros",
			invalidFileType: "Tipo de Ficheiro Inválido",
			onlyImagesAllowed: "Apenas ficheiros de imagem são permitidos",
			differentStatusQuestion:
				"Alguma encomenda tem um estado diferente do principal?",
			alternativeStatuses: "Estados Alternativos",
			alternativeStatusGroup: "Grupo de Estado Alternativo {0}",
			selectOrders: "Selecionar Encomendas",
			selectOrdersPlaceholder: "Selecionar quais encomendas têm este estado",
			alreadySelected: "(já selecionado)",
			addAnotherAlternativeStatus: "Adicionar Outro Estado Alternativo",
			selectAtLeastOneOrder:
				"Grupo de Estado Alternativo {0}: Por favor selecione pelo menos uma encomenda",
			provideDeliveredDate:
				"Grupo de Estado Alternativo {0}: Por favor forneça a data de entrega",
			noBoxesAssigned: "Nenhuma caixa atribuída a esta rota.",
			vehicleCheckIn: {
				title: "Inspeção do Veículo",
				odometer: "Odómetro (km)",
				fuel: "Combustível",
				tirePressure: "Pressão dos Pneus",
				lightsWorking: "Luzes a Funcionar",
				hasDefects: "Tem Defeitos",
				inspectionDate: "Data da Inspeção",
				generalNotes: "Notas Gerais",
				defectNotes: "Notas de Defeitos",
				defectPhotos: "Fotos de Defeitos",
			},
			openRoute: "Abrir Rota",

			// Show/hide toggles for the side panel and move-orders timeline
			showPanel: "Mostrar painel de detalhes",
			hidePanel: "Esconder painel de detalhes",
			showTimeline: "Mostrar timeline de mover encomendas",
			hideTimeline: "Esconder timeline de mover encomendas",
			timelineRequiresARoute:
				"Selecione pelo menos 1 rota para ativar esta opção.",
			timelineRequiresEligibleRoutes:
				"As rotas selecionadas não podem ser de um dia já passado nem estar finalizadas.",
			moveOrdersInTransitWarningTitle: "Rota já em trânsito",
			moveOrdersInTransitWarningContent:
				"As seguintes rotas já estão em trânsito: {0}. O condutor pode não ver as alterações feitas aqui. Tens a certeza que queres continuar?",
			moveOrdersInTransitWarningConfirm: "Continuar mesmo assim",

			// Move Orders Between Routes
			moveOrdersTitle: "Mover Encomendas Entre Rotas",
			moveOrdersHint: "Arraste uma paragem para outra rota para a mover.",
			moveOrdersHintSingleRoute:
				"Arraste uma paragem para reordenar a sequência de entrega.",
			moveOrdersPendingCountOne:
				"1 alteração pendente — escolha como confirmar.",
			moveOrdersPendingCountMany:
				"{0} alterações pendentes — escolha como confirmar.",
			moveOrdersDiscard: "Descartar Alterações",
			moveOrdersAdjustEtas: "Ajustar ETAs",
			moveOrdersOptimize: "Otimizar Rotas",
			moveOrdersCapacityWarning:
				"Esta rota excede a capacidade do veículo ({0}/{1} encomendas).",
			moveOrdersSuccess: "Encomendas movidas com sucesso",
			moveOrdersError: "Falha ao mover encomendas entre rotas",
			moveOrdersPreviewError:
				"Falha ao calcular a pré-visualização da otimização",
			moveOrdersOptimizeSuccess: "Rotas otimizadas com sucesso",
			moveOrdersAutoUpdatedNote:
				"Rotas de mota atualizadas automaticamente (pickup associado a uma van alterada): {0}.",
			moveOrdersAutoUpdatedTag: "Atualizada automaticamente",
			moveOrdersAutoUpdatedTagTooltip:
				"Esta rota foi recalculada porque o pickup dela depende de uma van que também mudou.",
			moveOrdersOptimizeError: "Falha ao aplicar a otimização",
			moveOrdersOptimizePreviewTitle: "Pré-visualizar Otimização",
			moveOrdersOptimizeCurrentLabel: "Atual",
			moveOrdersOptimizeProposedLabel: "Otimizado",
			moveOrdersOptimizeChangedCount: "{0} alteradas",
			moveOrdersOptimizeMovedFrom: "Vinha de: {0}",
			moveOrdersPickupCollectedAt: "Recolhe às {0}",
			moveOrdersOptimizeConfirm: "Confirmar",
			moveOrdersOptimizeCancel: "Cancelar",
			moveOrdersOptimizeSkippedWarning:
				"Não foi possível otimizar estas encomendas",
			moveOrdersOptimizeSkippedWarningDetail:
				"Estas encomendas não conseguem ser encaixadas na rota com as restrições atuais (ex.: janela horária). Enquanto isto acontecer, não é possível guardar esta otimização.",
			timelineLegendDepot: "Armazém",
			timelineLegendStop: "Paragem",
			timelineLegendMoved: "Movida de outra rota",
			timelineLegendRepositioned: "Reposicionada nesta rota",
			timelineLegendOutOfFormat: "Fora de formato",
			timelineLegendBundled: "Agrupada com outras encomendas",
			moveOrdersBundledWith: "Agrupada com: {0}",
			moveOrdersGroupedWithCount: "Agrupada com {0} encomendas",
			moveOrdersOutOfFormatWarning:
				"Encomenda fora de formato — pode não caber nesta rota (mota).",
			moveOrdersOutOfFormatConfirmTitle: "Encomenda fora de formato",
			moveOrdersOutOfFormatConfirmContent:
				"A encomenda {0} está classificada como fora de formato e pode não caber nesta rota de mota. Tens a certeza que queres continuar?",
			moveOrdersOutOfFormatConfirmOk: "Mover mesmo assim",
			timelineZoom: "Zoom",
			timelineZoomFit: "Ajustar à janela",
		},

		operationLinks: {
			title: "Links de Operações",
			description: "Links úteis para operações",
			cardView: "Cartões",
			listView: "Lista",
			noLinks: "Nenhum link disponível",
			group: "Grupo",
			link: "Link",
			openLink: "Abrir Link",
			copiedToClipboard: "Copiado para a área de transferência",
			copyFailed: "Falha ao copiar para a área de transferência",
		},
		geojsonZones: {
			title: "Zonas GeoJSON globais",
			subtitle:
				"Zonas partilhadas, não associadas a nenhum contrato. Qualquer contrato as pode usar como área de entrega ou filtro de veículo.",
			create: "Criar zona global",
			empty: "Ainda não existem zonas GeoJSON globais.",
			buffer: "Margem erro",
			noDescription: "Sem descrição",
			loadError: "Não foi possível carregar as zonas globais.",
			deleted: "Zona GeoJSON eliminada.",
		},

		sectorsMap: {
			title: "Mapa de Setores",
			description: "Carregue o ficheiro para começar",
			uploadPrompt: "Arraste ou selecione o ficheiro (.xlsx)",
			selectBusinessFirst: "Escolha primeiro o cliente",
			selectedFile: "Ficheiro selecionado",
			ordersLoaded: "Encomendas carregadas",
			onlyBike: "Mota / Zonas Negras",
			updateSector:
				"Clique num setor abaixo para mover os pontos selecionados para lá",
			moreOptions: "Mais opções",
			fullscreen: "Ecrã inteiro",
			newFile: "Novo Ficheiro",
			pointsSelected: "pontos selecionados",
			clickToSelect: "Clique nos pontos do mapa para os selecionar",
			clickSectorToSelect: "Clique num setor para selecionar tudo",
			hideSector: "Esconder setor",
			showSector: "Mostrar setor",
			hideEmptySectors: "Esconder setores sem encomendas",
			updateSelected: "Atualizar Selecionados",
			clearSelection: "Limpar Seleção",
			pointsMovedToSector: "pontos movidos para o setor",
			revertChanges: "Reverter para Original",
			revertLastChange: "Reverter Última Alteração",
			changesReverted: "Alterações revertidas",
			selection: "Seleção",
			sector: "Setor",
			orderId: "ID Encomenda",
			depot: "Armazém",
			download: "Descarregar Ficheiro de Setores",
			generateFinal: "Gerar Ficheiro Final",
			createOrders: "Criar Encomendas",
			createOrdersConfirm:
				"Isto vai criar encomendas reais no backoffice a partir dos setores atuais. Tens a certeza?",
			hiddenSectorsTitle: "Setores escondidos",
			hiddenSectorsMessage:
				"Tens setores escondidos no mapa (isso é só visual). Que fazer com as encomendas desses setores",
			includeHiddenSectors: "Incluir Escondidos",
			excludeHiddenSectors: "Excluir Escondidos",
			failureReasonOrderId: "Encomenda já existe",
			failureReasonDuplicateOrderId: "ID duplicado no ficheiro",
			failureReasonMissingFields: "Campos em falta",
			failureReasonDuplicateKey: "Chave duplicada",
			failureReasonDatabaseValidationFailed: "Falha de validação",
			failureReasonUnknownDatabaseError: "Erro desconhecido da base de dados",
			failureReasonUnknown: "Desconhecido",
			showIds: "Ver IDs",
			allFailed: "Falharam todas",
		},

		fleetDashboard: {
			title: "Frota de Veículos",
			selectVehicle: "Selecione um veículo",
			selectVehicleHint: "Clique num veículo no mapa para ver detalhes",
			stops: "Paragens",
			stop: "Paragem",
			noStops: "Sem paragens agendadas",
			noVehicles: "Nenhum veículo encontrado",
			selectBusinessHint: "Selecione um negócio para ver os veículos",
			vehiclesInFleet: "veículos na frota",
			errorLoadingFleet: "Erro ao carregar frota",
			totalVehicles: "Veículos",
			idle: "Parados",
			remainingDistance: "Distância Restante",
			remainingDuration: "Tempo Restante",
			remainingStops: "Paragens Restantes",
			nextStop: "Próxima Paragem",
			estimatedTime: "Tempo Estimado",
			avgSpeed: "Velocidade Média",
			onRoute: "em rota",
			perVehicle: "por veículo",
			toNextStop: "até paragem seguinte",
			avgPerVehicle: "média por veículo",
			thisVehicle: "neste veículo",
			movingVehicles: "veículos em movimento",
		},

		messaging: {
			title: "Mensagens",
			pageTitle: "Mensagens | Dingoo",
			createGroup: "Criar Grupo",
			createNewGroup: "Criar Novo Grupo",
			editGroup: "Editar Grupo",
			searchGroups: "Pesquisar grupos...",
			noSearchResults: "Sem resultados para a pesquisa.",
			noGroups: "Nenhum grupo criado ainda.\nClica no + para criar o primeiro.",
			selectGroup: "Seleciona um grupo para ver as mensagens",
			members: "membros",
			botActive: "Bot ativo",
			noMessages: "Nenhuma mensagem ainda. Diz olá! 👋",
			inputPlaceholder: "Escreve uma mensagem... (Enter para enviar)",
			groupName: "Nome do Grupo",
			groupNameRequired: "Nome do Grupo *",
			groupNamePlaceholder: "Ex: CTT Lisboa 1200",
			optional: "(opcional)",
			groupDescPlaceholder: "Descrição do grupo",
			botToggleDescription:
				"Quando ativo, o Dingoo Bot responde nas conversas ao ser mencionado com @agentD",
			driversRequired: "Motoristas *",
			selectedCount: "selecionado(s)",
			searchMember: "Pesquisar por nome ou email...",
			noMemberFound: "Nenhum membro encontrado",
			selectedMembers: "Membros selecionados",
			membersLabel: "Membros",
			inGroup: "no grupo",
			you: "(tu)",
			noMessagesPreview: "Sem mensagens",
			readReceiptsTitle: "Confirmações de leitura",
			seenBy: "Visto por",
			unread: "Por ler",
			seeWhoRead: "Ver quem leu",
			nobodyRead: "Ninguém leu ainda",
			mention: "Mencionar",
			roleDriver: "Motorista",
			roleBackoffice: "Backoffice",
			roleBot: "Assistente IA",
			botTyping: "Dingoo Bot está a escrever...",
			imageUnavailable: "Imagem não disponível",
			imageAlt: "anexo",
			today: "Hoje",
			yesterday: "Ontem",
			notifPrefTitle: "Notificações",
			notifAll: "Todas as mensagens",
			notifMentions: "Apenas quando mencionado(a)",
			notifNone: "Silenciado",
			notifAllShort: "Todas",
			notifMentionsShort: "Menções",
			notifNoneShort: "Silenciado",
			attachImage: "Enviar imagem",
			attachFile: "Enviar ficheiro",
			openFile: "Abrir",
			typingOne: "{name} está a escrever...",
			typingTwo: "{name1} e {name2} estão a escrever...",
			typingMany: "Várias pessoas estão a escrever...",
			archiveGroup: "Arquivar Grupo",
			archiveGroupConfirm:
				"Tem a certeza que deseja arquivar este grupo? Deixará de aparecer na lista de mensagens.",
			archiveGroupSuccess: "Grupo arquivado com sucesso.",
			archivedGroups: "Grupos Arquivados",
			showArchived: "Ver arquivados",
			hideArchived: "Ocultar arquivados",
			archivedBadge: "Arquivado",
			archivedNotice:
				"Este grupo está arquivado. Só podes visualizar as mensagens.",
		},
	},

	/* cSpell.language:en */
	en: {
		// Generic
		generic: {
			askToSave: "Deseja guardar as alterações antes de sair da página?",
			edit: "Edit",
			done: "Done",
			accept: "Accept",
			cancel: "Cancel",
			remove: "Remove",
			forget: "Forget User",
			delete: "Delete",
			deleteMessage: "Are you sure you want to delete?",
			success: "Success",
			active: "Active",
			expand: "Expand",
			toggle: "Toggle",
			save: "Save",
			yes: "Yes",
			no: "No",
			apply: "Apply",
			item: "Item",
			items: "Items",
			submit: "Submit",
			continue: "Continue",
			confirm: "Confirm",
			finish: "Finish",
			back: "Back",
			oops: "Oops",
			error: "Error",
			retry: "Retry",
			reset: "Reset",
			search: "Search",
			noResults: "No Results",
			clickHereTo: "Click here to {0}",
			requiredField: "{0} is a required field",
			duplicateEmail: "This email is already taken. Please use another email.",
			emptyList: "No {0} in List",
			leavePage: "Leave Page?",
			leave: "Leave",
			stay: "Stay",
			open: "Open",
			close: "Close",
			change: "Change",
			next: "Next",
			or: "or",
			free: "Free",
			send: "Send",
			selected: "Selected",
			selecteds: "Selected",
			swalEditTitle: "Cancel Edit?",
			swalEditDescription:
				"Cancelling edit will erase all the unsaved information!",
			leaveDescription:
				"Leaving this page will erase all the unsaved information!",
			swalDeleteTitle: "Delete {0}?",
			swalDeleteDescription:
				"By leaving this page, you'll erase all the {0} on your list",
			genericSelect: "Select {0}",
			select: "Select",
			addGeneric: "Add {0}",
			moreOptions: "More Options",
			all: "All",
			filter: "Filter",
			clear: "Clear filter",
			enable: "Enable",
			newF: "New",
			newM: "New",
			addNewF: "Add new {0}",
			addNewM: "Add new {0}",
			default: "Default",
			editGeneric: "Edit {0}",
			infinite: "Infinite",
			details: "Details",
			noItemsSelected: "No Items Selected",
			clearList: "Clear List",
			loading: "Loading...",
			view: "View",
			actions: "Actions",
			invalidUrl: "Invalid URL. Please remove HTTP prefix.",
			shop: "Shop",
			noEntries: "No Entries",
			chatWalktroughText1:
				"We've added several FAQs that will help you know and understand how the Shop2Grow product works. These FAQs are available from the chat icon at the bottom right of the screen.",
			chatWalktroughText2:
				"We are also available through chat to help you the best way on to setting up your store.",
			skip: "Skip",
			walkTrough: "walkthrough",
			clone: "Clone",
			download: "Download",
			upload: "Upload",
			template: "Download Template",
			export: "Export",
			import: "Import",
			defaultItem: "an item",
			defaultItemRecipient: "this {0}",
			demo: "Demo",
			previewOnly: "Preview Only",
			selectPaymentMethod:
				"Please select a payment method before updating your subscription.",
			basic: "Basic",
			advanced: "Advanced",
			editMode: "Edit Mode",
			print: "Print",
			code: "Code",
			filters: " Filters",
			changeImage: "Click here to add an image file or drag it into this box.",
			changeFile: "Click here to add a file or drag it into this box.",
			userImage: `This user don't have any image`,
			changeVideo: "Click here to add a video file or drag it into this box.",
			changeYoutubeVideo: "Insert youtube link",
			changeAudio: "Click here to add an audio file or drag it into this box.",
			everyF: "All",
			everyM: "All",
			generalInformation: "General Information",
			sync: "Sync",
			map: "Map",
			bundled: "Bundled",
		},

		notifications: {
			title: "Notifications",
			permissionDenied: "Permission Denied. Please check your permissions.",
			routeCreated: "Optmizer",
			routeCreatedBody:
				"The routes for the day {0} were successfully created for {1} with contract {2}.",
			routeCreatedError: "Error creating routes.",
			routeCreatedErrorBody: "Error creating routes. Please check the logs.",
			newNotificationTitle: "New Notification",
			newNotificationBody: "You have a new message.",
		},

		fields: {
			name: "Name",
			externalName: "External Name",
			address: "Address",
			addresses: "Addresses",
			country: "Country",
			state: "State",
			city: "City",
			zipCode: "Zip Code",
			description: "Description",
			phone: "Phone",
			phoneNumber: "Phone Number",
			phoneShort: "Tel.:",
			mobilePhone: "Mobile Number",
			email: "Email",
			seoUrl: "SEO Url",
			tags: "Tags",
			ccNumber: "CC Number",
			billingAddress: "Billing Address",
			shippingAddress: "Shipping Address",
			vat: "VAT",
			password: "Password",
			message: "Message",
			image: "Image",
			images: "Images",
			imgPlaceholder:
				"Try dropping some images here, or click to select files to upload",
			filesPlaceholder:
				"Try dropping your file here, or click to select a file",
			subTotal: "Subtotal",
			total: "Total",
			quantity: "Quantity",
			ordered: "Ordered",
			totalQuantity: "Total Quantity",
			discount: "Discount",
			registerDate: "Register Date",
			invalidEmail: "Email is not Valid",
			tax: "Tax",
			addedOn: "Added On",
			startDate: "Start Date",
			endDate: "End Date",
			startHour: "Start Hour",
			endHour: "End Hour",
			filename: "Filename",
			gender: "Gender",
			waitingForResults: "Waiting for Name or SKU...",
			link: "Link",
			date: "Date",
			otherRegions: "Other Zones",
			taxValues: "Tax Values",
			previewLink: "Preview Link",
			clickToUpload: "Click to Upload",
			photo: "Photo",
			shift: "Shift",
			defaultShift: "Default Shift",
			shiftEnd: "Shift End",
			shiftStart: "Shift Start",
			contractTypeName: "Contract Type Name",
			contractTypeUrl: "URL optimizer",
			isActive: "Is Active",

			// Select
			selectCountry: "Select Country",
			selectState: "Select State",
			selectFilters: "Select Filters",
			selectDiscount: "Select Discount",

			countries: "Countries",
			states: "States",

			// Pairs
			valuePair: "{0} / {1}",
			placeHolderPair: "{0} => {1}",

			code: "Abbreviation",
			bccEmail: "Email to receive orders",
			article: "Article",

			logo: "Logo",
			category: "Category",
			weight: "Weight",

			// SMS Options
			deliverySlotRangeMinutes: "Delivery Slot (ETD - X to ETD + X)",
			template: "Template",

			// Email:
			subject: "subject",
			recipients: "Recipients",

			loadSequenceType: "Load Sequence Type",

			// Service Times
			serviceTimeA: "Base Service Time",
			serviceTimeB: "Service Time per Box",

			addressNotes: "Address Notes",

			// Label Templete
			labelTemplate: "Label Template",
		},

		language: {
			header: "Language",
			defaultLanguage: "Default Language",
			languageNotActive:
				"Save the changes before changing the default language.",
			portuguese: "Portuguese",
			english: "English",
			german: "German",
			french: "French",
			spanish: "Spanish",
		},

		sidebar: {
			dashboard: "Dashboard",
			profile: "Profile",
			information: "Information",
			staff: "Staff",
			operationLinks: "Operation Links",
			settings: "Settings",
			logs: "Logs",
			users: "Users",
			businesses: "Clients",
			orders: "Orders",
			routes: "Routes",
			tenants: "Tenants",
			externalDeliveries: "External Deliveries",
			messaging: "Messages",
			sectorsMap: "Sectors Map",
			groups: {
				general: "General",
				operations: "Operations",
				team: "Team",
				system: "System",
			},
		},

		header: {
			account: "Account",
		},

		// Screens
		authentication: {
			welcome: "Welcome",
			header: "Authentication",
			register: "Register",
			login: "Login",
			logout: "Logout",
			signIn: "Sign in",
			confirmAccount: "Confirm Account",
			name: "Name",
			namePlaceholder: "Your name",
			email: "Email",
			emailPlaceholder: "Your email",
			password: "Password",
			passwordPlaceholder: "Your password",
			newPassword: "New password",
			newPasswordPlaceholder: "Enter new password",
			confirmPassword: "Confirm Password",
			confirmPasswordPlaceholder: "Repeat your password",
			forgotPassword: "Forgot your password? Click here.",
			loginFooter: "No account? Register here",
			registerFooter: "Do you have an account? Login here",
			resendCode1: "Have you not received your confirmation code? ",
			resendCode2: "Resend activation code",
			sendEmail: "Send Email",
			recoverPassword: "Recover Password",
			changePassword: "Change Password",
			changeEmail: "Change Email",
			newEmail: "New Email",
			repeatEmail: "Repeat Email",
			newEmailConfirm: "Confirm New Email",
			currentEmail: "Current Email",
			currentPassword: "Current Password",
			emailSent: "Email Sent Successfully",
			repeatPassword: "Repeat Password",
			rememberedPassword: "Did you remember your password?",
			adminPassword: "Admin Password",
			notLoggedIn: "You need to be logged in to access this page",
			noMatchPassword: "Passwords don't match",
			acceptSubtitle: "Please input a password to confirm your account.",
			confirmInvite: "Please type your password to accept invite.",
			goBackToLogin: "Go to the login screen",
			resendInviteEmail: "Resend Invitation Email",
			confirmResendInviteEmail: "Resend an invitation email to {0}?",
			signInFailed: "Sign-in failed",
			signInFailedTryAgain: "Sign-in failed. Please try again.",
			notAuthorized: "Access not authorized",
			notAuthorizedDescription:
				"Your account doesn't have backoffice access yet. Please contact an administrator.",
			welcomeBack: "Welcome back",
			enterPassword: "Enter your password",
			signInSubtitle: "Sign in to your Dingoo account",
			signingInAs: "You're signing in as",
			continueWithGoogle: "Continue with Google",
			forgetTitle:
				"Are you sure you want to forget the user {0}? This action will leave the user without access to the app and all the user information will be removed.",
			forgetConfirm: "Forget User",
			backoffice: "Backoffice",
		},

		acceptInvite: {
			header: "Accept Invite",
			title: "Hi {0}, {1} has invited you to belong {2}",
			title2: "Hi {0}, {1} has invited you to manage {2}",
			subTitle: "Please choose a password to confirm your account",
			expired: "This invitation link has expired",
		},

		notFound: {
			header: "Not Found",
		},

		importModal: {
			fileName: "Filename",
			size: "Size",
			import: "Import",
		},

		errors: {
			invalidArgs: "Invalid or missing arguments",
			invalidFields: "Invalid or missing fields",
			emailIsInvalid: "Email format is not valid",
			fillEmail: "Please input your email",
			fillPassword: "Please input your password",
			pleaseFillFormCorrectly: "Please fill the form correctly",
			fillField: "This field is mandatory",
			notSupportedFile: "File type not supported",
			nameIsEmpty: "Please fill name field",
			passwordsDontMatch:
				"Fields 'New password' and 'Confirm password' don't match",
			emailIsEmpty: "Please fill email field",
			fileTooBigorInvalid: "File size is larger than 8MB or file is corrupt",
			unsupportedFile: "File not supported",
			fileNotSupported: "File you tried to upload is not supported.",
			processingError: "Processing Error",
			imageProcessingError: "{images} could not be processed.",
			shiftDateError:
				"The shift end date has to be a previous date than the shift start one.",
		},

		profile: {
			profilePicture: "Profile Picture",
			role: "Role",
			editedSuccessfully: "Profile edited successfully",
			recurrence: "Recurrence",
			recurrenceActive: "Enable Recurrence",
			recurrenceUntil: "Recurrent until",
			recurringEndMissing: "Recurrence end date is mandatory.",
			recurrenceSuccess: "Recurrence settings saved successfully.",
			deleteRecurrence: "Delete Recurrence",
			noThankYou: "No Thank You",
			recurrenceTooltip: "Create recurrence",
			deleteRecurrenceDescription:
				"Do you want to delete recurrence on {date}?",
		},

		placeholders: {
			name: "Your name",
			email: "your@email.com",
			phoneNumber: "+351265000000",
			language: "Select a language option",
			languageSimplified: "Language",
			role: "Select a role",
			currentPassword: "actual password",
			newPassword: "new password",
			confirmPassword: "new password",
			newEmail: "new@email.com",
			page: "page",
			titlePage: "Page Title",
			link: "https://www.google.com/",
		},

		staff: {
			owner: "Owner",
			owners: "Owners",
			admin: "Administrator",
			marketing: "Marketing",
			editedSuccessfully: "User edited successfully",
			passwordChangedSuccessfully: "Password changed successfully",
			emailChangedSuccessfully: "Email changed successfully",
			wrongPassword: "Wrong password",
			emailInUse: "Email in use",
			status: "Status",
			confirmed: "Confirmed",
			pending: "Pending",
			createStaff: "Create User",
			createdSuccessfully: "User has been created successfully.",
			sysAdmin: "System Admin",
			addStaff: "Add User",
			editStaff: "Edit User",
			addOwner: "Add an Owner",
			editOwner: "Edit Owner",
			user: "User",
			archiveStaff: "Archive User",
			archived: "User has been archived successfully.",
			disableStaff: "Disable User",
			enableStaff: "Enable User",
			disabled: "User disabled successfully.",
			enabled: "User enabled successfully.",
			dispatcher: "Dispatcher",
			manager: "Manager",
			driver: "Driver",
			drivers: "Drivers",
			operator: "Operator",
			operators: "Operators",
			dashboardUser: "Dashboard User",
			serviceAccount: "Service Account (API only)",

			// Drivers
			expectedWorkingHours: "Expected Working Hours per Day",
			expectedWorkingDays: "Expected Working Days per Week",

			// Firebase
			firebaseUser: "Scanner Account",
			firebaseUserLinked: "Linked",
			firebaseUserNotLinked: "Not Linked",
			linkFirebaseUser: "Link Scanner",
			firebaseUserLinkedSuccessfully: "Scanner linked successfully.",
			noBackofficeAccess: "This account does not have backoffice access.",
			noPasswordWarning:
				"Without a password, the user can only sign in with Google or via a password setup link sent by email. Set a password now if email + password access is required.",
			businessesAndContracts: "Businesses & Contracts",
			allContracts: "All contracts",
			noBusinessesAssigned: "No businesses assigned.",
			addBusiness: "Add Business",
			businessRequired: "Select a business.",
			contractsRequired: "Select at least one contract or “All contracts”.",
			duplicatedBusiness: "This business has already been added.",
		},

		vehicles: {
			brand: "Brand",
			model: "Model",
			year: "Year",
			color: "Color",
			vehicleType: "Vehicle Type",
			licensePlate: "License Plate",
			capacity: "Capacity",
			pricePerMonth: "Price per Month",
			typeOfContract: "Type of Contract",
			contractStartDate: "Contract Start Date",
			contractEndDate: "Contract End Date",
			archived: "Vehicle has been archived successfully.",

			// Types of contract
			contractPaid: "Paid",
			contractPaying: "Paying",
			contractRenting: "Renting",
			contractLeasing: "Leasing",

			// Extra
			expectedWorkingHours: "Expected Working Hours per Day",
		},

		ranges: {
			today: "Today",
			thisMonth: "This month",
			lastMonth: "Last month",
			thisYear: "This year",
			lastYear: "Last year",
		},

		dashboard: {
			period: "Period",
			active: "Active",
			homepage: "Homepage",
			inStock: "In Stock",
			daily: "Dialy",
			monthly: "Monthly",
			newUsers: "New Users",
			newUsersContent: "New Users Content",
			uses: "Uses",
			androidUse: "Android Usage",
			androidUseContent: "Android Usage Content",
			iOSUse: "iOS Usage",
			iOSUseContent: "iOS Usage Content",
			webUse: "Web Usage",
			webUseContent: "Web Usage Content",
			contract: "Contract",
			sosButton: "Call Button",
			chatButton: "Chat Button",
			usage: "Users",
			videoAppointments: "Psychologic video-consultations",
			hotline: "Psychological Hotline",
			disturbances: "Diagnosed Disorders",
			contractDetails: "Contract Details",
			purchased: "Purchased",
			consumed: "Used",
			balance: "Balance",
			scheduled: "Scheduled Consultations",
			finished: "Finished Consultations",
			details: "See Detail",
			clicked: "Num. Clicks",
			usageApp: "App Usage",
			calls: "Calls",
			chats: "Chats",
			records: "Interventions Records",
			noData: "No data for the selected period.",
			selectPsychologist: "Select Psychologist",
			question1: "De forma geral, está satisfeito(a) com o serviço prestado?",
			question2: "Em que medida gostou do(a) psicólogo(a) que o(a) atendeu?",
			question3: "O(a) psicólogo(a) foi pontual no seu atendimento?",
			question4: "Sente-se melhor depois da intervenção psicológica realizada?",
			question5: "No seu entender, o número de consultas está a foi adequado?",
			question6: "Em caso de necessidade, voltaria a utilizar o serviço?",
			question7: "Quanto recomendaria este serviço a um colega?",
			question8:
				"Considera que esta intervenção ajudou que se sentisse mais motivado?",
			question9:
				"Com esta intervenção, tornou-se mais fácil gerir o equilíbrio entre a vida familiar e o trabalho?",
			question10:
				"Considera importante manter o serviço de apoio psicológico na sua organização?",
			notes: "Caso queira deixar alguma sugestão, por favor, escreva abaixo",
			reviewHelp:
				'De {0} a {1}, em que {2} é "{3}" e {4} corresponde a "{5}", por favor, classifique as seguintes afirmações relativas às vídeo-consultas de Psicologia realizadas com os psicólogos da TEAM 24.',
			notReally: "muito pouco",
			little: "pouco",
			few: "moderadamente",
			many: "muito",
			alot: "extremamente",
		},

		settings: {
			pages: "Pages",
			pagesDescription:
				"In this area you will be able to change the content of Terms & Condition and Privacy Policy",
			emailTemplates: "E-mail Settings",
			emailTemplatesDescription:
				"Setup email templated, used to sent emails to users, and also used to manage staff invitation",
			vehicles: "Vehicles",
			vehiclesDescription:
				"Register your fleet of vehicles and its caracteristics",
			addVehicle: "Add vehicle",
			editVehicle: "Edit vehicle",
			added: "Vehicle has been created successfully.",
			edited: "Vehicle has been edited successfully.",
			deleted: "Vehicle has been deleted successfully.",
			licensePlate: "License Plate",
			licensePlateRequired: "License Plate is a mandatory field.",
			nameRequired: "Name is a mandatory field.",
			typeRequired: "Type is a mandatory field.",
			urlRequired: "Url is a mandatory field.",
			capacityRequired: "Capacity is a mandatory field.",
			urlInvalid: "Url is not valid.",
			vehiclePlate: "Vehicle License Plate",
			vehicleType: "Vehicle Type",
			contractType: "Contract Type",
			optimizerType: "Optimizer Type",
			engineType: "Optimizer Engine",
			capacity: "Capacity",
			van: "Van",
			bike: "Bike",
			boxes: "Boxes",
			grids: "Grid",
			gridsDescription: "Register a grid to fill in routes",
			shifts: "Shift",
			shiftsDescription: "Register a shift to use in the orders",
			addGrid: "Add Grid",
			editGrid: "Edit Grid",
			addShift: "Add Shift",
			editShift: "Edit Shift",
			contractTypes: "Contract Types",
			contractTypesDescription: "Register a contract type.",
			food: "Food",
			parcel: "Parcel",
			pharmacy: "Pharmacy",
			contractUrl: "Optimizer Url",
			editContractType: "Edit Contract Type",
			addContractType: "Add Contract Type",
			uploadMasterData: "Upload Master Data",
			uploadMasterDataSubtitle:
				"Upload the Master Data file, to import clients to the system",
			userAlreadyExists: "There's already a client with that id",
			importedWithErrors:
				"Master Data file has been imported successfully but there are some clients that were not imported (see errors list).",
			imported: "Master Data file has been imported successfully.",
			masterData: "Master Data",
			systemConfigBanner:
				"Settings changed here directly affect the platform behaviour. Click an option to configure.",
			labelTemplates: "Label Templates",
			lastModifiedBy: "Last modified by",
			labelTemplatesDescription: "Manage HTML templates for label printing",
			labelTemplateAdded: "Label template created successfully.",
			labelTemplateEdited: "Label template updated successfully.",
			labelTemplateDeleted: "Label template deleted successfully.",
			notificationTemplates: "Notification Templates",
			notificationTemplatesDescription:
				"Manage notification templates sent to clients",
			geojsonZones: "GeoJSON Zones",
			geojsonZonesDescription:
				"Manage the global GeoJSON zones shared across every contract",
			notificationTemplateAdded: "Notification template created successfully.",
			notificationTemplateEdited: "Notification template updated successfully.",
			notificationEvent: "Event",
		},

		pages: {
			single: "Page",
			title: "Title",
			content: "Content",
			new: "New Page",
			isLink: "Redirect",
		},

		templates: {
			single: "Template",
		},

		emails: {
			single: "E-mail",
			tags: "Tags",
			preview: "Preview",
			subject: "Subject",
			cc: "CC",
			templates: "E-mail Templates",
			invite: "Staff Invite",
			edited: "E-mail template saved successfully.",
			plainText: "Plain text",
		},

		serverErrors: {
			title: "Internal Server Error",
			subTitle: "It's not you, it's us!",
			refresh: "Go Back to Previous Page",
			backToDashboard: "Go to Dashboard",
			wentWrong: "Something went wrong.",
			subscribeTopicError: "Error subscribing to topic.",
		},

		logs: {
			dateRange: "Date Range",
			userId: "User Id",
			url: "Url",
			token: "Token",
			codes: "Codes",
			methods: "Methods",
			sources: "Sources",
			types: "Types",
		},

		emailTemplates: {
			generalEmail: "Generic E-mail",
			marketingEmail: "Marketing E-mail",
			accountConfirmationCode: "User Account Confirmation by Code",
			recoverPasswordCode: "User Password Recovery by Code",
			accountConfirmationLink: "User Account Confirmation by Link",
			recoverPasswordLink: "User Password Recovery by Link",
			reservationEmail: "User Reservation E-mail",
			staffAccountConfirmation: "Staff Account Confirmation for BO",
			staffRecoverPassword: "Staff Recover Password for BO",
			changeEmailCode: "Change Email (Code)",
			changeEmailLink: "Change Email (Link)",
		},

		businesses: {
			business: "Client",
			new: "New Client",
			header: "Business",
			plural: "Businesses",
			info: "General",
			deleted: "Delete Client",
			fullInfo: "Business Information",
			schedule: "Schedule",
			settings: "Settings",
			financial: "Financial",
			addressLine1: "Address Line 1",
			addressLine2: "Address Line 2",
			location: "Location",
			businessInformation: "Business Information",
			vatNumber: "VAT Number",
			invoiceName: "Invoice Name",
			iban: "IBAN",
			bic: "BIC",
			emptyVat: "Vat number field can not be empty.",
			invalidVat: "Vat number is not valid.",
			invalidName: "Name is a mandatory field.",
			invalidOwnerName: "Owner name is a mandatory field.",
			invalidOwnerEmail: "Owner e-mail is either empty or invalid.",
			emptyCountry: "Country is a mandatory field.",
			emptyState: "State is a mandatory field.",
			ownerPhone: "Owner Phone",
			emptyOwnerNumber: "Owner phone number is a mandatory field.",
			approved: "Approved",
			approve: "Approve",
			added: "Business has been created successfully.",
			edited: "Business has been updated successfully.",
			removed: "Business has been deleted successfully.",
			categories: "Categories",
			minPriceRange: "Min. Price Range",
			maxPriceRange: "Max. Price Range",
			wallet: "Wallet",
			emptyAddress: "Address is a mandatory field.",
			invalidMaxRange:
				"Max. price range needs to be higher than min price range.",
			balance: "Balance",
			allTransactions: "All transactions",
			monthBalance: "Month Balance",
			totalAccumulated: "Accumulated Balance",
			transactions: "Transactions",
			receiptValue: "Receipt Amount",
			netBalance: "Net Balance",
			total: "Total",
			user: "User",
			contracts: "Contracts",
			typeContract: "Type",
			descriptionContract: "Description",
			addContract: "Add contract",
			editContract: "Edit contract",
			contractAdded: "Contract has been created successfully.",
			contractEdited: "Contract has been updated successfully.",
			contractRemoved: "Contract has been deleted successfully.",
			startDateRequired: "Contract start date is a mandatory field.",
			endDateRequired: "Contract end date is a mandatory field.",
			valueRequired: "Contract consultations is a mandatory field.",
			datesIntervalInvalid: "Invalid date interval.",
			notDeliveredReasons: "Not Delivered Reasons",
			notDeliveredReasonsHelper:
				"This will override the original not delivered reasons",
			internalReason: "Internal Reason",
			externalCode: "External Code",
			internalCode: "Internal Code",
			reasonText: "Client Reason",
			addReason: "Add Reason",
			notDeliveredReasonsMissingFields: "Not Delivered Reasons Missing Fields",
			duplicateInternalCode: "Duplicate Internal Code",
			notDeliveredReasonsMissingLanguage:
				"Not Delivered Reasons Must Have At Least One Common Language Filled",

			// Uniform api calls strings
			apiCallSetup: "API Call Setup",
			apiCallSetupHelper: "Configure external API calls for this business",
			addApiCall: "Add API Call",
			apiCallName: "Name",
			apiCallUrl: "Endpoint URL",
			apiCallMethod: "HTTP Method",
			apiCallAuthMethod: "Authentication",
			apiCallAuthNone: "None",
			apiCallAuthApiKey: "API Key",
			apiCallAuthBearer: "Bearer Token",
			apiCallAuthBasic: "Basic Auth",
			apiCallHeaderName: "Header Name",
			apiCallApiKey: "API Key",
			apiCallBearerToken: "Bearer Token",
			apiCallUsername: "Username",
			apiCallPassword: "Password",
			apiCallBodySchema: "Body Schema (JSON)",
			apiCallHelpTitle: "Help — API Calls",
			apiCallHelpUrlLabel: "URL",
			apiCallHelpUrlDesc:
				"The full URL of the external API endpoint to be called.",
			apiCallHelpMethodLabel: "HTTP Method",
			apiCallHelpMethodDesc:
				"The HTTP method to use for the call (GET, POST, PUT, PATCH, DELETE).",
			apiCallHelpAuthLabel: "Authentication",
			apiCallHelpAuthDesc:
				"Select the authentication method and fill in the corresponding fields. Options: None, API Key (custom header), Bearer Token (Authorization: Bearer …), and Basic Auth (username + password).",
			apiCallHelpBodySchemaLabel: "Body Schema",
			apiCallHelpBodySchemaDesc:
				"Defines the JSON structure of the request body sent to the external API. Use {{field}} placeholders for dynamic variables replaced at runtime. Ex.: { orderId: {{orderId}}, status: {{status}} }",
			apiCallInvalidJson: "The body schema contains invalid JSON.",
			apiCallNameRequired: "API call name is required.",
			apiCallUrlRequired: "API call URL is required.",
			apiCallTrigger: "When",
			apiCallTriggerPlaceholder: "Select trigger",
			apiCallTriggerOnRouteStart: "Route start (in transit)",
			templates: "Labels",
			labelName: "Name",
			noLabels: "No label templates configured.",
			labelActive: "Active",
			labelInactive: "Inactive",
			labelNew: "New Label",
			labelEdit: "Edit Label",
			labelTemplate: "HTML Template",
			labelPreview: "Preview",
			labelVariables: "Variables",
			labelNameRequired: "Label name is required.",
			labelTemplateRequired: "Label HTML is required.",
			labelDeleteActiveError: "Cannot delete an active label.",
			labelDeleteConfirm: "Delete label",
			labelDeleteConfirmDesc: "Are you sure you want to delete this label?",
			labelInvalidVars: "Invalid variables in label",
			labelAvailableVars: "Available variables",
			labelAIAssistant: "AI Assistant",
			labelAIPlaceholder: "Describe what you want to change in the label...",
			labelAIGenerate: "Generate",
			labelAIGenerating: "Generating...",
			labelAIDiffBefore: "Before",
			labelAIDiffAfter: "After",
			notificationsTab: "Notifications",
			notificationsDescription:
				"Associate notification templates by event type.",
			finishedOptimizedRoute: "Optimized Route",
			finishedOptimizedRouteDesc:
				"Sent when the optimizer finishes creating the routes.",
			routeAssignedToDriver: "Route Assigned to Driver",
			routeAssignedToDriverDesc:
				"Sent to the driver when a route is assigned to them.",
			notificationTemplateTitle: "Title",
			notificationTemplateBody: "Body",
			notificationTemplateNameRequired:
				"Notification template name is required.",
			notificationTemplateContentRequired:
				"Notification template needs at least a title or body in one language.",
			notificationTestSent: "Test notification sent successfully.",
			notificationTestBtn: "Test",
		},

		tenants: {
			tenant: "Tenant",
			tenants: "Tenants",
			new: "New Tenant",
			edit: "Edit Tenant",
			domain: "Domain",
			authMethods: "Auth Methods",
			database: "Database",
			contactName: "Contact Name",
			contactEmail: "Contact Email",
			contactPhone: "Contact Phone",
			primaryColor: "Primary Color",
			secondaryColor: "Secondary Color",
			notes: "Notes",
			created: "Tenant created successfully.",
			edited: "Tenant updated successfully.",
			activated: "Tenant activated successfully.",
			deactivated: "Tenant deactivated successfully.",
			deleted: "Tenant deleted successfully.",
			nameRequired: "Tenant name is required.",
			authMethodsRequired: "Select at least one authentication method.",
		},

		contracts: {
			name: "Contract",
			business: "Business",
			new: "New Contract",
			type: "Contract Type",
			parcel: "Parcel",
			food: "Food Distribution",
			startDate: "Start Date",
			endDate: "End Date",
			baseLocation: "Base Location",
			searchAddress: "Search Address",
			startPostcode: "Postcode Range Start",
			endPostcode: "Postcode Range End",
			invalidWorkAreaInterval: "Last range added is not valid.",
			workAreas: "Work Areas",
			geojsonZones: "GeoJSON Zones",
			geojsonDeliveryZonesTitle: "Delivery zones (validation)",
			geojsonDeliveryZonesPlaceholder: "Select zones for validation",
			geojsonLibraryTitle: "Available GeoJSONs",
			geojsonNoAvailable: "No GeoJSONs created for this contract.",
			geojsonInUse: "in use",
			geojsonAddZone: "Add GeoJSON zone",
			geojsonZoneName: "Zone name",
			geojsonBuffer: "Buffer (km)",
			geojsonPaste: "Paste",
			geojsonUpload: "Upload file",
			geojsonDraw: "Draw",
			geojsonPastePlaceholder:
				"Paste GeoJSON here (FeatureCollection, Feature or geometry)",
			geojsonUploadHint: "Drag or click to upload a .geojson/.json file",
			geojsonDrawHint: "Click on the map to draw the polygon.",
			geojsonRedraw: "Clear / redraw",
			geojsonPreview: "Preview",
			geojsonCreate: "Create zone",
			geojsonCreated: "GeoJSON zone created.",
			geojsonInvalid: "Invalid GeoJSON. Provide a valid polygon.",
			geojsonNameRequired: "Please provide a zone name.",
			geojsonNoZones: "No zones attached to this contract.",
			geojsonSelectExisting: "Add existing zone",
			geojsonRemove: "Remove",
			geojsonDeleteTitle: "Delete GeoJSON zone",
			geojsonDeleteMessage:
				'Are you sure you want to delete the zone "{name}"? This action cannot be undone.',
			geojsonDeleteInUseWarning:
				"Warning: this zone is in use for delivery validation. Deleting it will also remove it from the delivery zones.",
			geojsonDeleteNotInUse:
				"This zone is not used in any delivery validation.",
			geojsonContractZonesTitle: "Contract zones",
			geojsonZoneDescription: "Description",
			geojsonGlobal: "global",
			geojsonEdit: "Edit",
			geojsonEditZone: "Edit GeoJSON zone",
			geojsonSave: "Save changes",
			geojsonUpdated: "GeoJSON zone updated.",
			geojsonModes: {
				deliveryArea: "Delivery area",
				onlyVan: "Only van",
				onlyBike: "Only bike",
			},
			geojsonShowOnMap: "Show on map",
			geojsonHideFromMap: "Hide from map",
			geojsonModesLegend: "What each mode means:",
			geojsonModesHelp: {
				deliveryArea:
					"Bounds where the contract delivers. An order outside every delivery area is flagged with an address error for review. With no areas set, any address is accepted.",
				onlyVan:
					'Orders inside this zone are marked "only van" at import and are never assigned to a bike.',
				onlyBike:
					'Orders inside this zone are marked "only bike" at import — used for areas a van cannot reach or park in.',
			},
			lots: "Lots",
			lotName: "Lot Name",
			lotsPlaceholder: "LotName1, LotName2, LotName3",
			attachments: "Attachments",
			noData: "No attachments added.",
			startDateMandatory: "Start date is a mandatory field.",
			endDateMandatory: "End date is a mandatory field.",
			typeMandatory: "Contract type is a mandatory field.",
			addAttachment: "Add Attachment",
			editAttachment: "Edit Attachment",
			attachment: "Attachment",
			attachmentMandatory: "You need to add a file first.",
			descriptionMandatory: "Description is a mandatory field.",
			document: "Document",
			horeca: "Horeca",
			baseLocationAddress: "Base Location Address",
			baseLocationAddressMandatory: "The base location address is mandatory.",
			warehouseId: "Warehouse ID",
			optimizerParams: "Optimizer Parameters",
			preProcessingParams: "Pre-Processing Parameters",
			preProcessingNucleoidDistance: "Nucleoid Distance",
			preProcessingMaxVanStopsPerHour: "Max Van Stops per Hour",
			preProcessingVicinityDistance: "Vicinity Distance",
			preProcessingStreetPriority: "Street Priority",
			preProcessingStreetPriorityNone: "None (no street map)",
			preProcessingStreetPriorityRank: "Street ranking (rank)",
			preProcessingStreetPriorityScore: "Street score",
			preProcessingStreetPriorityHelper:
				"None (no street map): the van is assigned only by proximity to other vans and by proximity clusters (DBSCAN) — no important-street recognition for this contract. Use when there is no street map relevant to this contract's area.\n\nStreet ranking (rank): the van is assigned to streets known to be important, starting with the highest-ranked ones (lower number = more important). When the per-hour stop limit forces a choice between competing streets, the higher-ranked one wins. Stops near those streets are promoted too; anything left over goes through proximity clustering (DBSCAN).\n\nStreet score: same as Street ranking, but sorts streets by score — highest to lowest — instead of by ranking number.",
			functionalities: "Functionalities",
			allowCheckOut: "Checkout",
			allowCheckOutHelper:
				"Allow the driver to use the mobile app to checkout the order using barcode scanner",
			sms: "SMS",
			onTransitSms: "On Transit SMS",
			onTransitSmsHelper:
				"Sends automatic SMS to customer when the order enters transit",
			scannerEmail: "Scanner Email",
			templateVariablesLegend:
				"Use the following variables in your template to dynamically insert values.",
			templateVariablesFrom: "Slot start time",
			templateVariablesTo: "Slot end time",
			templateVariablesClientName: "The client's name",
			templateVariablesOrderId: "The order ID",
			templateVariablesBusinessName: "The business name",
			templateVariablesTotalBoxes: "The total number of boxes",
			smsTestMode: "SMS Test Mode",
			smsTestModeHelper:
				"Enables SMS test mode - messages will only be sent to numbers defined in the test list",
			serviceTime: "Services Times",
			useAddress: "Use Address for Navigation",
			useAddressHelper:
				"Uses customer address for navigation instead of GPS coordinates",
			getDeliveryOptions: "Photo and delivery options mandatory",
			getDeliveryOptionsHelper:
				"Makes it mandatory to take photo and select delivery options when completing an order",
			beforeDeliverySms: "Before Delivery SMS",
			beforeDeliverySmsHelper:
				"Sends automatic SMS to customer when the previous order is completed",
			requiredSignature: "Required Signature",
			requiredSignatureHelper:
				"Requires customer signature to complete delivery",
			invalidBagSize: "Invalid bag size",
			invalidOutOfFormatSize: "Invalid out of format size",
			showUntreatedBoxes: "Show Untreated Boxes",
			showUntreatedBoxesHelper:
				"Turning this off will hide untreated boxes in the mobile app",
			separateUntreated: "Separate Untreated",
			separateUntreatedHelper:
				"When enabled, after aggregation any untreated orders are moved into their own unrouted route, sharing a single fake box",
			cancelUntreated: "Cancel Untreated",
			cancelUntreatedHelper:
				"When enabled, after aggregation any untreated orders are automatically cancelled.",
			mergeBikeRoutes: "Merge Bike Routes",
			mergeBikeRoutesHelper:
				"When aggregation ends, merges bike routes sharing the same pickup point and close to each other, up to each bike's capacity, and assigns a bike to each route.",
			bikeMergeMinTimeSaved: "Minimum time saved to merge warehouse routes",
			bikeMergeMinTimeSavedHelper:
				"Two bike routes leaving the warehouse are only merged into one trip if that saves the bike at least this percentage of time. Doesn't apply to bikes picking boxes up from a van.",
			bikeMergeMinTimeSavedExample:
				"With {percent}%, two 30 min trips merge if the merged trip takes up to {minutes} min.",
			bikeMergeMinTimeSavedNever:
				"With 100%, warehouse bike routes are never merged.",
			bikeMergeMinTimeSavedRecommended:
				"The higher it is, the fewer routes get merged. Recommended: 20%.",
			fleetEngine: "Fleet Engine",
			fleetEngineHelper: "When enabled, Google Fleet Engine will be used",
			bundles: "Bundle Orders",
			useBundlesHelper:
				"When enabled, orders for same client will be bundled together",
			externalDelivery: "External Delivery",
			externalDeliveryHelper:
				"Configure external delivery partners for this contract",
			externalDeliveryActive: "Active",
			externalDeliveryWarehousePhone: "Warehouse Phone",
			externalDeliveryWarehouseName: "Warehouse Name",
			externalDeliveryWarehouseAddress: "Warehouse Address (optional)",
			externalDeliveryWarehouseAddressHelper:
				"When set, this address overrides the contract's address and coordinates as the Uber pickup location for deliveries. Coordinates are auto-populated from the address.",
			externalDeliveryWarehouseShowMap: "Show map",
			externalDeliveryWarehouseHideMap: "Hide map",
			externalDeliveryStoreId: "Store ID",
			externalDeliveryBarcodeType: "Barcode Type",
			externalDeliveryAcceptedPhoneTypes: "Accepted Phone Types",
			externalDeliveryAcceptedPhoneTypesHelper:
				"Only orders with one of these phone types are eligible for external delivery.",
			externalDeliveryAcceptedPhoneTypesRequired:
				"Select at least one accepted phone type.",
			externalDeliveryPhoneTypeMobile: "Mobile",
			externalDeliveryPhoneTypeLandline: "Landline",
			externalDeliveryPhoneTypeNone: "No phone",
			externalDeliverySmsTemplate: "SMS Template",
			externalDeliveryPickupNotes: "Pickup Notes",
			externalDeliveryTestMode: "Test Mode",
			externalDeliveryTestModeHelper:
				"When enabled, the courier will be simulated by a robot that completes the process automatically",
			externalDeliveryMessagingChannel: "Messaging channel",
			externalDeliveryMessagingChannelHelper:
				"Posts messages to a backoffice group at key points of the Uber delivery. Pick the group and which events to notify.",
			externalDeliveryMessagingChannelGroup: "Group",
			externalDeliveryMessagingChannelGroupPlaceholder: "Select group",
			externalDeliveryMessagingChannelEvents: "Events to notify",
			externalDeliveryEventEnRoutePickup: "En route to pickup",
			externalDeliveryEventArrivingPickup: "Arriving at pickup",
			externalDeliveryEventPickupComplete: "Pickup collected",
			externalDeliveryEventAllDeliveriesDone: "All deliveries done",
			externalDeliveryEventPartialReturn: "Returning with parcels",
			externalDeliveryEventReturnsCompleted: "Returns completed",
			externalDeliveryEventRouteCancelled: "Deliveries cancelled",
			externalDeliveryFieldsMandatory:
				"All external delivery fields are mandatory when a partner is active.",
			externalDeliveryInvalidPhone: "The warehouse phone number is not valid.",
			externalDeliveryStoreIdNoSpaces:
				"The store ID cannot contain whitespaces.",
		},

		contractTypes: {
			contractUpdated: "Contract has been updated successfully.",
		},

		orders: {
			order: "Order",
			preparation: "Preparation",
			concluded: "Concluded",
			filterByStatus: "Filter by status",
			filterByAttributes: "Filter by attributes",
			packageLabel: "Package",
			withBag: "With bag",
			boxOnly: "Box only",
			phoneLabel: "Phone",
			noPhone: "No phone",
			withPhone: "With phone",
			anyPhone: "Any",
			homePhone: "Home",
			mobilePhone: "Mobile",
			paymentLabel: "Payment",
			withPayment: "With payment",
			withoutPayment: "Without payment",
			deliveryModeLabel: "Delivery Mode",
			onlyBikeOption: "Bike only",
			vanOption: "Van",
			anyVanOption: "Any",
			forcedVanOption: "Forced",
			promotedVanOption: "Promoted",
			geoZoneLabel: "GeoJSON Zone",
			geoZonePlaceholder: "Select zone",
			geoZoneSelectContract: "Select a contract to choose a zone",
			geoZoneAutomatic: "Automatic",
			geoZoneUberLimits: "Uber limits ({0} km)",
			registered: "Registered",
			addressConfirmation: "Address Confirmation",
			picking: "Picking",
			packing: "Packing",
			loading: "Loading",
			on_transit: "On Transit",
			delivered: "Delivered",
			notDelivered: "Not Delivered",
			orderDelivered: "Delivered",
			orderNotDelivered: "Not Delivered",
			orderCancelled: "Cancelled",
			orderReturned: "Returned",
			cancelled: "Cancelled",
			returned: "Returned",
			refunded: "Refunded",
			processing: "Processing",
			dispute: "Dispute",
			selectBusiness: "Select a business",
			selectContract: "Select a contract",
			orderId: "Order ID",
			payment: "Payment",
			deliveryDate: "Delivery Date",
			deliveredTime: "Delivered Time",
			deliveredDate: "Delivered Date",
			clientName: "Client Name",
			phoneNumber: "Phone Number",
			orderAddress: "Address",
			userAddress: "Shipping Address",
			deliverySlot: "Slot",
			latitude: "Latitude",
			longitude: "Longitude",
			validationDateError: "Date: Order has no delivery date.",
			validationPostCodeError:
				"Post Code: Order has no post code or it's invalid.",
			validationAddressError:
				"Address: Order has no delivery address or needs to be validated.",
			validationCoordinatesError:
				"Coordinates: It was impossible to retrive address coordinates.",
			validationSlotError: "Slot: Order has no delivery slot or it's invalid.",
			validationPhoneError: "Phone: Order has no phone number.",
			definePicking: "Move to Picking",
			refresh: "Reload",
			edited: "Order has been edited successfully.",
			editedPlural: "Orders have been edited successfully.",
			imported: "Order have been imported successfully.",
			download: "Download Template",
			uploadFile: "Click or drag a file into this box.",
			import: "Import",
			upload: "Import Orders",
			uploadBoxes: "Upload Boxes",
			pleaseSelectBoth: "Please select a client and a contract",
			pleaseSelectBusiness: "Please select a client",
			pleaseSelectContract: "Please select a contract",
			pleaseSelectDate: "Please select a date",
			orderDate: "Order Date",
			existingOrderDate: "Existing Order Date",
			slot: "Delivery Slot",
			status: "Status",
			formattedOrderAddress: "Formatted Order Address",
			clientAddress: "Client Address",
			newAddress: "New Address",
			importedErrors: "Unimported Orders (Errors)",
			missingOrderId: "Missing Order ID",
			duplicateOrderId: "This order ID already exists in the system.",
			duplicateOrderIdInFile: "Duplicate order IDs found in the file.",
			failedUpdate: "Failed to update.",
			importedWithErrors:
				"Orders have been imported successfully but there are some that were not imported (see errors list).",
			serviceType: "Service Type",
			totalWeight: "Total Weight",
			totalVolume: "Total Volume",
			itemsQuantity: "Total No. Items",
			finalAddress: "Shipping Address",
			noErrors: "This order has no errors to display.",
			orderErrors: "Errors",
			coordinates: "Coordinates",
			defineAddress: "Define Shipping Address",
			normal: "Normal",
			phoneMandatory: "Phone is a mandatory field.",
			invalidPhone: "The phone number is not valid.",
			addressMandatory: "Shipping address is a mandatory field.",
			selectShippingAddress: "Please select a shipping address or create one.",
			bagId: "Bag ID",
			totalBoxes: "Num. Boxes",
			packaging: "Packaging",
			packagingType: "Packaging Type",
			bag: "Bag",
			box: "Box",
			boxId: "Box ID",
			addBox: "Add New Box",
			weight: "Weight",
			fillBagFields: "All bag fields are mandatory.",
			fillOneBox: "You need to create at least one box.",
			boxMissingFields: "There are at least one box with missing fields.",
			classificationPreset: "Preset",
			classificationManual: "Manual",
			tabBags: "Bags",
			tabOutOfFormat: "Out of format",
			sizeVerySmall: "Very small",
			sizeSmall: "Small",
			sizeMedium: "Medium",
			sizeLarge: "Large",
			sizeVeryLarge: "Very large",
			currentClassification: "Current classification",
			suggestedClassification: "Suggestion",
			unclassified: "Unclassified",
			classificationReadOnly:
				"The classification can only be changed while the order is in packing.",
			alreadyClassifiedTitle: "Order already classified",
			alreadyClassifiedContent:
				"This order already has a classification. Do you want to replace it?",
			replace: "Replace",
			bagIdMustStartWithHash: "The bag ID must start with #.",
			bulkClassificationLabel: "Bulk classification",
			bulkClassificationShort: "Bulk",
			undoBulkClassification: "Undo bulk classification",
			reclassifyBulk: "Reclassify",
			bulkUndoConfirm:
				"{0} order(s) will go back to unclassified. Do you want to continue?",
			bulkReclassifyTitle: "Reclassify {0} order(s)",
			bulkUpdatedSuccess: "{0} order(s) updated.",
			bulkMixedTitle: "Invalid selection",
			bulkMixedDescription:
				"Only orders that were classified in bulk at the same time can be undone or reclassified.",
			bulkValidGroups: "Bulk classifications in the selection",
			bulkInvalidOrders: "Ineligible orders",
			bulkSelectOnlyGroup: "Select only this group",
			bulkGroupOrders: "{0} order(s)",
			bulkReasonNotBulk: "Not bulk classified",
			bulkReasonNotPacking: "No longer in packing",
			bulkReasonNotFound: "Not found",
			createBox: "Create Boxes",
			moveToPacking: "Move to Packing",
			sendBackToPacking: "Send Back to Packing",
			routes: "Routes",
			routeName: "Route Name",
			routeDate: "Route Date",
			gradeId: "Cargo Shelf ID",
			loadingOrder: "Loading Order",
			evalyzeId: "Evalyze ID",
			routeInfo: "Route Data",
			routeBoxes: "Route Boxes",
			position: "Cargo Shelf Position",
			gradeIdMandatory: "Shelf ID is a mandatory field.",
			vanMandatory: "You need to select a license plate.",
			routeEdited: "Route has been edited successfully.",
			published: "Published",
			driver: "Driver",
			missingMandatoryFields: "Missing mandatory fields",
			addressNumber: "No.",
			addressFloor: "Floor",
			invalidPostCode: "Missing or invalid post code (XXXX-XXX)",
			invalidDateFormat: "Invalid date format (YYYY-MM-DD)",
			invalidSlot: "Invalid From/To field (HH:MM)",
			invalidBagId: "Invalid Bag ID (#1, #2 or #3)",
			savePacking: "Save Packing",
			aggregateBags: "Aggregate Bags",
			aggregation: "Aggregation",
			inRoute: "In Route",
			finished: "Finished",
			grid: "Grid",
			line: "Line",
			column: "Column",
			depth: "Depth",
			route: "Route",
			readyToVan: "Ready To Van",
			readyToLoad: "Ready to load",
			dispatching: "Dispatching",
			moveToReadyToVan: "Move to Ready To Van",
			moveToDispatching: "Move to Dispatching",
			moveToOnTransit: "Move to On Transit",
			readyToDeliver: "Ready to deliver",
			readyToDispatch: "Ready to dispatch",
			vehicle: "Vehicle",
			warehouse: "Warehouse",
			stopType: "Stop Type",
			address: "Address",
			archiveMessage: "Are you sure you want to archive this?",
			archive: "Archive",
			outOfFormatBoxes: "Out of format boxes",
			outOfFormat: "Out of Format",
			readyBoxes: "Already Boxed",
			duplicateBoxId: "Box ID already in use",
			aggregationBoxNoId: "No ID yet",
			aggregationTemporary: "Temporary",
			aggregationFinalized: "Finalized",
			aggregationOrdersLabel: "ORDERS",
			aggregationTreated: "treated",
			aggregationNoOrders: "No orders",
			aggregationBoxesTitle: "Aggregation Boxes",
			aggregationNoBoxes: "No boxes available",
			aggregationBoxSingular: "box",
			aggregationBoxPlural: "boxes",
			aggregationFinalizedLabel: "finalized",
			aggregationEnterBoxId: "Enter box ID...",
			aggregationFinalizeBox: "Finalize Box",
			aggregationUntreatedWarning: "untreated order(s). Finalize anyway?",
			aggregationCancel: "Cancel",
			aggregationFinalizeConfirm: "Finalize",
			aggregationFinalizeAll: "Finalize Aggregation",
			outOfRouteBoxes: "Out of route boxes",
			progress: "Progress",
			selectDriver: "Select Driver",
			selectGrid: "Select Grid",
			selectVehicle: "Select Vehicle",
			selectOrderStatus: "Select Order Status",
			complaints: "Complaints",
			billing: "Billing",
			partialDelivered: "Partially Delivered",
			mixedFailed: "Mixed Failed",
			orderDeliveryInfo: "Delivery Info",
			notes: "Notes",
			images: "Images",
			nextStatus: "Next Status",
			previousStatus: "Previous Status",
			staff: "Staff",
			orderLogs: "Order Logs",
			operationsBlock: "Operations Block",
			deliveryHistory: "Delivery History",
			arrivalTime: "Arrival Time",
			departureTime: "Departure Time",
			estimatedTimeArrival: "Estimated Time Arrival",
			estimatedTimeDeparture: "Estimated Time Departure",
			boxes: "Boxes",
			noBoxes: "This order has no boxes yet",
			marketPlaceCode: "Marketplace code",
			clientId: "Client ID",
			notDeliveredReason: "Not delivered reason",
			orderNotInPacking: `Order not in "Packing" status`,
			orderNotFound: "Order not Found",
			pile: "Pile",
			lot: "Lot",
			route4meSyncMessage:
				"This actions will rewrite all routes from this contract on selected day using route4me, do you wish to continue?",
			route4meSyncOnTransitWarnMessage:
				"Warning! There are orders in transit, syncing with route4me will affect the currently in progress route and might cause problems for driver. Do you wish to continue?",
			syncRoute4me: "Sync from route4me",
			syncRoute4meTooltip: "Sync routes of this contract from route4me",
			synced: "Route has been synced successfully.",
			showOnMap: "Show on Map",

			// Confirmation Modal
			confirmSendToOptimizer: "Confirm send to optimizer",
			confirmSendToOptimizerMessage:
				"Are you sure you want to send {0} order{1} to the optimizer?",
			confirmSendToOptimizerDescription:
				"This action will process the orders for route creation.",
			confirmSend: "Yes, send",

			notReasonError: "The field 'Not delivered reason' is mandatory.",
			emptyNotesField:
				"You choose the reason 'Other Reason', please fill the notes field.",
			validateAddress: "Validate Address",
			warnings: "Warnings",
			gridLoadSequence: "Load Sequence",
			loadType: "Sequence Type",
			visualGrid: "Visual Grid",
			tableView: "Table View",
			gridVisualization: "Grid Visualization (Depth Layers)",
			legend: "Legend",
			gridLegendText:
				"Hover over boxes to see details. Blue boxes are loaded, white boxes are empty positions.",
			emptyPosition: "Empty position",
			noLoadSequenceData: "No load sequence data available",
			errors: "Errors",
			noWarning: "No Warning",
			noError: "No error",
			errorFindingRoute: "Error finding route.",
			bundledOrders: "Bundled Orders",
			bundledOrdersStatus: "Bundled Orders Status",
			optimizer: "Optimizer",

			// Service Types
			serviceTypes: {
				delivery: "Delivery",
				collection: "Collection",
			},

			stopTypes: {
				delivery: "Delivery",
				pickup: "Pickup",
			},

			// Address Validation
			addressValidationSuccess: "Address validated successfully.",
			addressesValidationSuccess: "Addresses validated successfully.",
			addressValidationError: "Error validating address.",
			incompleteAddressTitle: "Incomplete address",
			incompleteAddressWarning:
				"This address has no door number. Saving it could automatically validate a future order for a different house on the same street. Save anyway?",
			saveAnyway: "Save anyway",
			validateWithoutSaving: "Validate without saving",
			validateAndSave: "Validate and save",
			originalAddress: "Original Address",
			formattedAddress: "Formatted Address",
			validationSource: "Validation",
			validatedBySystem: "Validated by system",
			validatedByUser: "Validated by user",
			confirmBoxCompletion: "Confirm Box Completion",
			warningCannotUndo: "Warning: This action cannot be undone!",
			yesFinishBox: "Yes, Finish Box",
			allLots: "All Lots",

			// Bulk Lot Update
			bulkLotUpdateSuccess: "Lot updated successfully for the selected orders.",

			// Change Status
			statusChangeRequirements: "Status change requirements not met:",
			changeStatusTo: "Change status to {0}",
			changeMultipleOrdersStatus: "Change {0} orders to status {1}",
			ordersSelectedOf: "{0} of {1} orders selected",
			allOrdersSameStatus: "All orders must have the same status",
			multipleStatuses: "Multiple statuses",
			noNextStatus: "No next status available",
			sendToOptimizerToCreateRoutes:
				"Send {0} orders to optimizer to create routes",
			allOrdersMustHaveBoxesOrBags:
				"All orders must have boxes or bags assigned",
			allOrdersMustHaveBoxes: "All orders must have boxes assigned",
			bagsNotAllowedInNonParcel: "Bags are not allowed in non-parcel contracts",
			statusUpdated: "Status Updated",
			updateFailed: "Update Failed",
			statusUpdateError: "Failed to update order status",
			ordersInThePastCannotBeSent:
				"Orders with a past delivery date cannot be sent",
			ordersWithErrorsCannotBeSentToPicking:
				"Orders with errors cannot be sent to picking",
			closerWarningTitle: "Slot/Shift Mismatch",
			closerWarningDescription:
				"The following orders have a slot different from the shift. Select the ones you want to send to the optimizer.",
			closerWarningSend: "Send {0} orders",
			shift: "Shift",
			externalSplitTitle: "External Delivery",
			externalSplitDescription:
				"{0} of the {1} selected orders are eligible for external delivery. Choose how to send them to the optimizer.",
			externalSplitOptionSplit: "Create external routes separately",
			externalSplitOptionSplitHint:
				"Two optimizations: the {0} eligible orders first, bike only, then the remaining {1}.",
			externalSplitOptionExternalOnly: "Send only the eligible orders",
			externalSplitOptionExternalOnlyHint:
				"Optimizes the {0} eligible orders, bike only. The rest stay in packing.",
			externalSplitOptionNonExternalOnly: "Send only the non-eligible orders",
			externalSplitOptionNonExternalOnlyHint:
				"Optimizes the remaining {0} orders. The eligible ones stay in packing.",
			externalSplitOptionAllInternal: "Send all together as non-external",
			externalSplitOptionAllInternalHint:
				"A single optimization with all {0} orders, with no special handling.",
			externalSplitIneligibleTitle: "Not eligible ({0})",
			externalSplitExcludedNotice:
				"Orders that are not sent stay in packing and can be sent later.",
			externalSplitEligibilityFailed:
				"Could not check external delivery eligibility.",
			externalSplitFutureTitle:
				"{0} order(s) can only be assigned to the partner {1}",
			externalSplitFutureDescription:
				"The routes are created now, but external delivery is same-day: they only become assignable on {0}.",
			externalSplitAssignableTomorrow: "tomorrow",
			externalSplitAssignableInDays: "in {0} days",
			orderInformation: "Order Information",
			ordersToAggregate: "orders to aggregate",
			ordersToValidate: "orders to validate",
			temporaryOrderPendingProcessing: "temporary order pending processing",
			temporaryOrdersPendingProcessing: "temporary orders pending processing",
			temporaryOrder: "Temporary Order",
			temporaryOrders: "Temporary Orders",
			temporaryOrdersFooter:
				"These orders are temporarily stored and pending processing",
			treated: "Treated",
			importOrdersSubtitle: "Import to address confirmation",
			importBoxesTitle: "Boxes / Bags",
			importBoxesSubtitle: "For orders in packing",
			downloadLabel: "Download Label",
			openOrder: "Open Order",
			openRoute: "Open Route",
			deleteOrder: "Delete Order",
			changeLot: "Change Lot",
			deleteOrders: "Delete {0} order(s)",
			actionsOnlyAddressConfirmation:
				"Change lot and delete are only available for orders in address confirmation",
			confirmDeleteTitle: "Confirm Order Deletion",
			confirmDeleteWarning: "Warning: This action cannot be undone!",
			confirmDeleteBody:
				"You are about to permanently delete {0} order(s). They will be removed from the system completely.",
			confirmDeleteSingleBody:
				"You are about to permanently delete order {0}. It will be removed from the system completely.",
			ordersToDelete: "Order(s) to be deleted:",
			updateLotTitle: "Update Lot in Bulk",
			updateLotButton: "Update {0} order(s)",
			updateLotHeader: "Bulk Lot Update",
			updateLotBody:
				"You are about to update the lot for {0} order(s). Please enter the new lot value below.",
			updateLotNewLot: "New Lot",
			updateLotPlaceholder: "Enter new lot value",
			updateLotSelected: "Selected Orders:",
			updateLotCurrent: "Current:",
			selectColumns: "Select columns",
			selectAllColumns: "All",
			resetColumns: "Default",
			columnsVisibleCount: "{0} of {1} columns visible",
			columnsDragHint: "Drag to reorder the columns",
			senderName: "Sender",
		},

		routes: {
			name: "Route",
			status: "Status",
			type: "Route Type",
			types: {
				van: "Van",
				bike: "Bike",
				fr: "Unrouted",
			},
			numberOfDeliveries: "Number of Deliveries",
			numberOfPickups: "Number of Pickups",
			allContracts: "All",
			contractRequiredForAction:
				'Select a specific contract (not "All") to do this action.',
			routesSelected: "{0} Routes Selected",
			toBeImplemented: "TO BE IMPLEMENTED ({0} routes selected)",
			multipleDates: "Multiple Dates",
			selectAll: "Select All",
			selectNone: "Select None",
			untreatedBoxesWarning:
				"This order was not treated during aggregation and will not be shown to driver",
			someUntreatedBoxesWarning:
				"Some orders were not treated during aggregation and will not be shown to driver",
			aggregateOrders: "Aggregate Orders",
			notDeliveredReason: "Not Delivered Reason",
			filterByStatus: "Filter by Status",
			filterByVan: "Filter by Van",
			vanWithId: "Van {0}",
			searchRoutes: "Search routes...",
			multiSelectHint:
				"This checkbox selects all. To pick only some, use Ctrl+click (⌘+click on Mac) on the table rows.",
			exportRoute: "Export Route",
			exportLoadSequence: "Export Load Sequence",
			routeName: "Route Name",
			progress: "Progress",
			stops: "Stops",
			orders: "Orders",
			routeNotFound: "Route not found",
			enterRouteName: "Enter route name",
			gridUpdated: "Grid Updated",
			updateFailed: "Update Failed",
			gridUpdateSuccess: "Route grid has been updated successfully",
			gridUpdateError: "Failed to update route grid",
			vehicleUpdated: "Vehicle Updated",
			vehicleUpdateSuccess: "Route vehicle has been updated successfully",
			vehicleUpdateError: "Failed to update route vehicle",
			bikeCapacityWarningTitle: "Bike capacity too small",
			bikeCapacityWarning:
				'This route has {boxes} boxes and the bike "{vehicle}" only carries {capacity}. Assign it anyway?',
			bikeCapacityWarningConfirm: "Assign anyway",
			bikeCapacityWarningCancel: "Cancel",
			bikeCapacityOption: "{capacity} boxes",
			driverUpdated: "Driver Updated",
			driverUpdateSuccess: "Route driver has been updated successfully",
			driverUpdateError: "Failed to update route driver",
			routeNameUpdated: "Route Name Updated",
			routeNameUpdateSuccess: "Route name has been updated successfully",
			routeNameUpdateError: "Failed to update route name",
			externalDelivery: "External Delivery",
			selectExternalProvider: "Select Provider",
			assignToExternal: "Assign to External Provider",
			externalDeliveryConfirm:
				"Are you sure you want to give these orders to an external driver ({0})?",
			externalDeliverySuccess:
				"Orders successfully assigned to external provider",
			externalDeliveryError: "Failed to assign orders to external provider",
			externalEligibilityColumn: "External",
			pickupColumn: "Pickup",
			pickupWarehouse: "Warehouse",
			pickupVanTooltip: "This pickup is at stop {0} of van {1}.",
			pickupVanTooltipNoName: "This pickup is at stop {0} of the van.",
			externalEligibleTooltip:
				"This route can be assigned to external delivery.",
			externalNotEligibleTooltip:
				"This route cannot be assigned to external delivery.",
			externalWarningTooltip:
				"Assignable, but some orders have a landline or no number (the warehouse number will be used).",
			externalAssignedTooltip:
				"This route is already assigned to external delivery.",
			externalDeliveryPendingBatches:
				"There are batches still being processed by the external partner. Wait until they finish before requesting a new batch.",
			externalDeliveryMultiSummary:
				"{0} route(s) and a total of {1} order(s) will be assigned.",
			externalDeliveryNotEligible:
				"Route must be in dispatching, today, of bike type, and not already assigned to an external provider.",
			externalDeliveryMultiNotEligible:
				"All selected routes must be in dispatching, today, of bike type, and not already assigned to an external provider.",
			externalDeliveryPartialSuccess:
				"Partial assignment: {0} route(s) failed and can be retried.",
			externalDeliveryFailedTitle: "Failed Routes",
			externalDeliveryFailedDescription:
				"The following routes could not be assigned to the external provider:",
			externalDeliveryCount: "External Deliveries",
			ordersWillBeSent: "orders will be sent (untreated orders excluded)",
			allOrdersUntreated:
				"All orders are untreated and cannot be sent to an external provider.",
			externalDeliveryPartner: "Partner",
			externalDeliveryStatus: "Status",
			externalDeliveryCourier: "Courier",
			externalDeliveryPickupEta: "Pickup ETA",
			externalDeliveryDropoffEta: "Dropoff ETA",
			externalDeliveryTracking: "Tracking",
			externalDeliveryReturnPincode: "Return Pincode",
			externalDeliveryBarcode: "Barcode",
			externalDeliveryManifestItems: "Manifest Items",
			externalDeliveryAssignedAt: "Assigned at",
			externalDeliveryBatchingStatus: "Batch Status",
			externalDeliveryBatches: "External Batches",
			externalDeliveryStatusFlow: "Status Flow",
			deliveryProgress: "Delivery Progress",
			deliveryProgressInternal: "Internal Delivery",
			deliveryProgressExternal: "External Delivery",
			showAllStatuses: "Show all statuses",
			showKeyStatuses: "Show key statuses only",
			deliveryNoLocationData: "No location data to display",
			deliveryNoStatusEvents: "No status events to display",
			externalDeliveryStatusPending: "Pending",
			externalDeliveryStatusAssigned: "Assigned",
			externalDeliveryStatusEnRoutePickup: "En Route to Pickup",
			externalDeliveryStatusArrivingPickup: "Arriving at Pickup",
			externalDeliveryStatusPickupComplete: "Pickup Complete",
			externalDeliveryStatusOutForDelivery: "Out for Delivery",
			externalDeliveryStatusArrivingDropoff: "Arriving at Dropoff",
			externalDeliveryStatusDelivered: "Delivered",
			externalDeliveryStatusReturning: "Returning",
			externalDeliveryStatusNotDelivered: "Not Delivered",
			externalDeliveryStatusCancelled: "Cancelled",
			externalReturnsReturning: "Returning",
			externalReturnsReturned: "Returned",
			externalReturnsStatus: "Return",
			externalBatchProgress: "Progress",
			externalBatchProgressFailed: "Failed",
			externalBatchProgressPending: "Pending",
			externalReturnsProgress: "Returns",
			externalReturnsWarning:
				"{0} not delivered and not returned — needs checking",
			externalReturnsNoReturn: "No return",
			externalReturnsReturnFailed: "Return failed",
			externalReturnsFailedAt: "Failed at",
			externalBatchingProcessing: "Processing",
			externalBatchingPartnerAccepted: "Partner Accepted",
			externalBatchingSearching: "Searching...",
			externalBatchingInProgress: "In Progress",
			externalBatchingCompleted: "Completed",
			externalBatchesTitle: "External Batches",
			externalBatchesEmpty: "No external batches for the selected filters",
			externalBatchesOrders: "orders",
			externalBatchesOrder: "order",
			externalBatchesVehicle: "Vehicle",
			externalBatchesPhone: "Phone",
			externalBatchesRoute: "Route",
			updateError: "An error occurred while updating",
			routeNumber: "Route Number",
			routeProgress: "Route Progress",
			delivered: "Delivered",
			deliveredCollection: "Collected",
			notDelivered: "Not Delivered",
			onTransit: "On Transit",
			finished: "Finished",
			addresses: "Addresses",
			routeMap: "Route Map",
			routesMap: "Routes Map",
			colorByRoute: "By Route",
			colorByRouteType: "By Type",
			colorByContract: "By Contract",
			showAllOnMap: "Show all",
			recenter: "Recenter",
			attachments: "Attachments",
			depot: "Depot",
			order: "Order",
			eta: "ETA",
			etd: "ETD",
			service: "Service",
			slot: "Slot",
			stopNumber: "Stop",
			stopType: "Stop Type",
			currentStatus: "Current Status",
			deliverySlot: "Delivery Slot",
			changeStatus: "Change Status",
			externalOverrideTitle: "Status Override (External Delivery)",
			externalOverrideWarning:
				"Last resort. Use only to correct the internal status when the external partner reported a wrong final status. The external delivery data is kept. The change is recorded with your name, date and notes.",
			externalOverrideSubmit: "Apply Override",
			externalOverrideSuccess: "Order status overridden to {0}",
			externalOverrideNotesRequired:
				"Notes are required to record the reason for the override",
			newStatus: "New Status",
			deliveredDateTime: "Delivered Date & Time",
			arrivalTime: "Arrival Time",
			departureTime: "Departure Time",
			uploadFile: "Upload File",
			updateStatus: "Update Status",
			statusUpdated: "Status Updated",
			statusUpdateSuccess: "Route status changed to {0}",
			statusUpdateSuccessMultiple: "{0} routes status changed to {1}",
			statusUpdateError: "Failed to update route status",
			provideNotDeliveryReason: "Please provide a non-delivery reason",
			notesRequiredForOther: "Notes field is required when reason is 'Other'",
			orderIdNotFound: "Order ID not found",
			statusChangeRequirements: "Requirements not met:",
			changeStatusTo: "Change status to {0}",
			changeMultipleRoutesStatus: "Change {0} routes to status {1}",
			allRoutesSameStatus: "All routes must have the same status",
			mustHaveAddresses: "Must have at least one address",
			addressesMissingLocation: "{0} address(es) missing location data",
			vehicleMustBeAssigned: "Vehicle must be assigned",
			gridMustBeAssigned: "Grid must be assigned for van routes",
			driverMustBeAssigned: "Driver must be assigned",
			mustHaveDeliveryAddresses: "Must have delivery addresses",
			notScheduledForToday: "Not scheduled for today",
			alreadyOnTransit: "Already on transit - final status",
			transitWarningMessage:
				"The driver should put the route into transit via the app. Doing it in the backoffice should only be a last resort. Are you sure you want to continue?",
			exportRouteSuccess: 'Route "{0}" exported successfully.',
			noLoadSequenceData: "No load sequence data available for this route.",
			selectDriver: "Select a driver",
			selectVehicle: "Select a vehicle",
			selectGrid: "Select a grid",
			started: "Started",
			statusChangesOnlyOnTransit:
				"Status changes are only available for orders in 'On Transit' status or after.",
			statusChangesBlockedDueToRestarted:
				"Status changes are blocked because the order is already in a new day.",
			outOfFormatBoxes: "Out of Format Boxes",
			outOfFormat: "Out of Format",
			duplicateBoxId: "Box ID already in use",
			aggregationBoxNoId: "No ID yet",
			aggregationTemporary: "Temporary",
			aggregationFinalized: "Finalized",
			aggregationOrdersLabel: "ORDERS",
			aggregationTreated: "treated",
			aggregationNoOrders: "No orders",
			aggregationBoxesTitle: "Aggregation Boxes",
			aggregationNoBoxes: "No boxes available",
			aggregationBoxSingular: "box",
			aggregationBoxPlural: "boxes",
			aggregationFinalizedLabel: "finalized",
			aggregationEnterBoxId: "Enter box ID...",
			aggregationFinalizeBox: "Finalize Box",
			aggregationUntreatedWarning: "untreated order(s). Finalize anyway?",
			aggregationCancel: "Cancel",
			aggregationFinalizeConfirm: "Finalize",
			aggregationFinalizeAll: "Finalize Aggregation",
			bikePickup: "Pickup Box From Van",
			startTime: "Start Time",
			endTime: "End Time",
			routeDuration: "Duration",

			// Address/Order Form Errors
			validationError: "Validation Error",
			fixFormErrors: "Please fix the errors in the form before submitting.",
			arrivalTimeRequiredWhenDepartureTimeSet:
				"Arrival time is required when departure time is set.",
			departureTimeRequiredWhenArrivalTimeSet:
				"Departure time is required when arrival time is set.",
			arrivalTimeCannotBeAfterDepartureTime:
				"Arrival time cannot be after departure time.",

			// Fleet Tracking
			fleetTracking: {
				speed: "Speed",
				direction: "Direction",
				remainingStops: "Remaining stops",
				remainingDistance: "Remaining distance",
				remainingDuration: "Remaining time",
				lastUpdate: "Last update",
				errorTracking: "Error tracking vehicle location",
				errorInitializing: "Failed to initialize fleet tracking",
				deliveryStop: "Delivery Stop",
				orders: "order(s)",
				noTrackingId: "No tracking ID available",
				liveTracking: "Tracking",
				standardMap: "Standard Map",
				fullscreen: "Fullscreen",
				legendSuccess: "Delivered",
				legendFailed: "Not Delivered",
				legendInTransit: "In Transit",
				legendEnroute: "En route",
				legendArrived: "Arrived at destination",
				legendOutcomeLocation: "Delivery/non-delivery location",
				legendMarkers: "Markers",
				legendRoutes: "Route",
				legendRouteCompleted: "Completed route",
				legendRouteActive: "Active route",
				legendRouteRemaining: "Remaining route",
				legend: "Legend",
			},

			// Address Details Modal
			partialUpdate: "Partial Update",
			ordersUpdatedPartially:
				"{0} of {1} orders updated successfully. {2} order(s) failed to update.",
			ordersUpdatedSuccessfully: "{0} orders updated successfully",
			boxes: "Boxes",
			deliveryLocation: "Delivery Location",
			plannedLocation: "Planned Location",
			actualDeliveryLocation: "Actual Delivery Location",
			selectDateAndTime: "Select date and time",
			selectTime: "Select time",
			enterNotes: "Enter notes...",
			uploadLimit: "Upload Limit",
			uploadLimitDescription: "You can only upload up to 2 files",
			invalidFileType: "Invalid File Type",
			onlyImagesAllowed: "Only image files are allowed",
			differentStatusQuestion:
				"Does any order have a different status than the main one?",
			alternativeStatuses: "Alternative Statuses",
			alternativeStatusGroup: "Alternative Status Group {0}",
			selectOrders: "Select Orders",
			selectOrdersPlaceholder: "Select which orders have this status",
			alreadySelected: "(already selected)",
			addAnotherAlternativeStatus: "Add Another Alternative Status",
			selectAtLeastOneOrder:
				"Alternative Status Group {0}: Please select at least one order",
			provideDeliveredDate:
				"Alternative Status Group {0}: Please provide delivered date",
			noBoxesAssigned: "No boxes assigned to this address.",

			vehicleCheckIn: {
				title: "Vehicle Check-In",
				odometer: "Odometer (km)",
				fuel: "Fuel",
				tirePressure: "Tire Pressure",
				lightsWorking: "Lights Working",
				hasDefects: "Has Defects",
				inspectionDate: "Inspection Date",
				generalNotes: "General Notes",
				defectNotes: "Defect Notes",
				defectPhotos: "Defect Photos",
			},
			openRoute: "Open Route",

			// Show/hide toggles for the side panel and move-orders timeline
			showPanel: "Show details panel",
			hidePanel: "Hide details panel",
			showTimeline: "Show move-orders timeline",
			hideTimeline: "Hide move-orders timeline",
			timelineRequiresARoute: "Select at least 1 route to enable this option.",
			timelineRequiresEligibleRoutes:
				"Selected routes can't be from a past day or already finished.",
			moveOrdersInTransitWarningTitle: "Route already in transit",
			moveOrdersInTransitWarningContent:
				"The following routes are already in transit: {0}. The driver may not see changes made here. Are you sure you want to continue?",
			moveOrdersInTransitWarningConfirm: "Continue anyway",

			// Move Orders Between Routes
			moveOrdersTitle: "Move Orders Between Routes",
			moveOrdersHint: "Drag a stop onto another route to move it.",
			moveOrdersHintSingleRoute:
				"Drag a stop to reorder the delivery sequence.",
			moveOrdersPendingCountOne: "1 pending change — choose how to confirm.",
			moveOrdersPendingCountMany:
				"{0} pending changes — choose how to confirm.",
			moveOrdersDiscard: "Discard Changes",
			moveOrdersAdjustEtas: "Adjust ETAs",
			moveOrdersOptimize: "Optimize Routes",
			moveOrdersCapacityWarning:
				"This route exceeds the vehicle capacity ({0}/{1} orders).",
			moveOrdersSuccess: "Orders moved successfully",
			moveOrdersError: "Failed to move orders between routes",
			moveOrdersPreviewError: "Failed to compute the optimization preview",
			moveOrdersOptimizeSuccess: "Routes optimized successfully",
			moveOrdersAutoUpdatedNote:
				"Bike routes auto-updated (pickup tied to a changed van): {0}.",
			moveOrdersAutoUpdatedTag: "Auto-updated",
			moveOrdersAutoUpdatedTagTooltip:
				"This route was recalculated because its pickup depends on a van that also changed.",
			moveOrdersOptimizeError: "Failed to apply the optimization",
			moveOrdersOptimizePreviewTitle: "Preview Optimization",
			moveOrdersOptimizeCurrentLabel: "Current",
			moveOrdersOptimizeProposedLabel: "Optimized",
			moveOrdersOptimizeChangedCount: "{0} changed",
			moveOrdersOptimizeMovedFrom: "Came from: {0}",
			moveOrdersPickupCollectedAt: "Picked up at {0}",
			moveOrdersOptimizeConfirm: "Confirm",
			moveOrdersOptimizeCancel: "Cancel",
			moveOrdersOptimizeSkippedWarning: "These orders couldn't be optimized",
			moveOrdersOptimizeSkippedWarningDetail:
				"These orders can't be fitted into the route under its current constraints (e.g. time window). While that's the case, this optimization can't be saved.",
			timelineLegendDepot: "Depot",
			timelineLegendStop: "Stop",
			timelineLegendMoved: "Moved from another route",
			timelineLegendOutOfFormat: "Out of format",
			timelineLegendBundled: "Bundled with other orders",
			moveOrdersBundledWith: "Bundled with: {0}",
			moveOrdersGroupedWithCount: "Grouped with {0} orders",
			moveOrdersOutOfFormatWarning:
				"Out-of-format order — may not fit this route (bike).",
			moveOrdersOutOfFormatConfirmTitle: "Out-of-format order",
			moveOrdersOutOfFormatConfirmContent:
				"Order {0} is classified as out-of-format and may not fit on this bike route. Are you sure you want to continue?",
			moveOrdersOutOfFormatConfirmOk: "Move anyway",
			timelineZoom: "Zoom",
			timelineZoomFit: "Fit to view",
		},

		operationLinks: {
			title: "Operation Links",
			description: "Useful links for operations",
			cardView: "Cards",
			listView: "List",
			noLinks: "No links available",
			group: "Group",
			link: "Link",
			openLink: "Open Link",
			copiedToClipboard: "Copied to clipboard",
			copyFailed: "Failed to copy to clipboard",
		},
		geojsonZones: {
			title: "Global GeoJSON zones",
			subtitle:
				"Shared zones, not tied to any contract. Any contract can use them as a delivery area or a vehicle filter.",
			create: "Create global zone",
			empty: "No global GeoJSON zones yet.",
			buffer: "Buffer",
			noDescription: "No description",
			loadError: "Could not load the global zones.",
			deleted: "GeoJSON zone deleted.",
		},

		sectorsMap: {
			title: "Sectors Map",
			description: "Upload the file to get started",
			uploadPrompt: "Drag and drop or select the file (.xlsx)",
			selectBusinessFirst: "Select a business first",
			selectedFile: "Selected file",
			ordersLoaded: "Orders loaded",
			onlyBike: "Bike / Dark Spots",
			updateSector: "Click a sector below to move the selected points there",
			moreOptions: "More options",
			fullscreen: "Fullscreen",
			newFile: "New File",
			pointsSelected: "points selected",
			clickToSelect: "Click points on the map to select them",
			clickSectorToSelect: "Click a sector to select all of it",
			hideSector: "Hide sector",
			showSector: "Show sector",
			hideEmptySectors: "Hide sectors with no orders",
			updateSelected: "Update Selected",
			clearSelection: "Clear Selection",
			pointsMovedToSector: "points moved to sector",
			revertChanges: "Revert to Original",
			revertLastChange: "Revert Last Change",
			changesReverted: "Changes reverted",
			selection: "Selection",
			sector: "Sector",
			orderId: "Order ID",
			depot: "Depot",
			download: "Download Sectors File",
			generateFinal: "Generate Final File",
			createOrders: "Create Orders",
			createOrdersConfirm:
				"This will create real orders in the backoffice from the current sectors. Are you sure?",
			hiddenSectorsTitle: "Hidden sectors",
			hiddenSectorsMessage:
				"You have sectors hidden on the map (visual only). What should happen to their orders",
			includeHiddenSectors: "Include Hidden",
			excludeHiddenSectors: "Exclude Hidden",
			failureReasonOrderId: "Order already exists",
			failureReasonDuplicateOrderId: "Duplicate ID in the file",
			failureReasonMissingFields: "Missing fields",
			failureReasonDuplicateKey: "Duplicate key",
			failureReasonDatabaseValidationFailed: "Validation failed",
			failureReasonUnknownDatabaseError: "Unknown database error",
			failureReasonUnknown: "Unknown",
			showIds: "Show IDs",
			allFailed: "All failed",
		},

		fleetDashboard: {
			title: "Fleet Vehicles",
			selectVehicle: "Select a vehicle",
			selectVehicleHint: "Click on a vehicle on the map to see details",
			stops: "Stops",
			stop: "Stop",
			noStops: "No scheduled stops",
			noVehicles: "No vehicles found",
			selectBusinessHint: "Select a business to view vehicles",
			vehiclesInFleet: "vehicles in fleet",
			errorLoadingFleet: "Error loading fleet",
			totalVehicles: "Vehicles",
			idle: "Idle",
			remainingDistance: "Remaining Distance",
			remainingDuration: "Remaining Time",
			remainingStops: "Remaining Stops",
			nextStop: "Next Stop",
			estimatedTime: "Est. Time",
			avgSpeed: "Avg Speed",
			onRoute: "on route",
			perVehicle: "per vehicle",
			toNextStop: "to next stop",
			avgPerVehicle: "avg per vehicle",
			thisVehicle: "this vehicle",
			movingVehicles: "vehicles moving",
		},

		messaging: {
			title: "Messages",
			pageTitle: "Messages | Dingoo",
			createGroup: "Create Group",
			createNewGroup: "Create New Group",
			editGroup: "Edit Group",
			searchGroups: "Search groups...",
			noSearchResults: "No results found.",
			noGroups: "No groups yet.\nClick + to create the first one.",
			selectGroup: "Select a group to view messages",
			members: "members",
			botActive: "Bot active",
			noMessages: "No messages yet. Say hello! 👋",
			inputPlaceholder: "Write a message... (Enter to send)",
			groupName: "Group Name",
			groupNameRequired: "Group Name *",
			groupNamePlaceholder: "E.g.: CTT Lisboa 1200",
			optional: "(optional)",
			groupDescPlaceholder: "Group description",
			botToggleDescription:
				"When active, Dingoo Bot replies in conversations when mentioned with @agentD",
			driversRequired: "Drivers *",
			selectedCount: "selected",
			searchMember: "Search by name or email...",
			noMemberFound: "No member found",
			selectedMembers: "Selected members",
			membersLabel: "Members",
			inGroup: "in group",
			you: "(you)",
			noMessagesPreview: "No messages",
			readReceiptsTitle: "Read receipts",
			seenBy: "Seen by",
			unread: "Unread",
			seeWhoRead: "See who read",
			nobodyRead: "Nobody has read it yet",
			mention: "Mention",
			roleDriver: "Driver",
			roleBackoffice: "Backoffice",
			roleBot: "AI Assistant",
			botTyping: "Dingoo Bot is typing...",
			imageUnavailable: "Image not available",
			imageAlt: "attachment",
			today: "Today",
			yesterday: "Yesterday",
			notifPrefTitle: "Notifications",
			notifAll: "All messages",
			notifMentions: "Only when mentioned",
			notifNone: "Muted",
			notifAllShort: "All",
			notifMentionsShort: "Mentions",
			notifNoneShort: "Muted",
			attachImage: "Send image",
			attachFile: "Send file",
			openFile: "Open",
			typingOne: "{name} is typing...",
			typingTwo: "{name1} and {name2} are typing...",
			typingMany: "Several people are typing...",
			archiveGroup: "Archive Group",
			archiveGroupConfirm:
				"Are you sure you want to archive this group? It will no longer appear in the messages list.",
			archiveGroupSuccess: "Group archived successfully.",
			archivedGroups: "Archived Groups",
			showArchived: "Show archived",
			hideArchived: "Hide archived",
			archivedBadge: "Archived",
			archivedNotice: "This group is archived. You can only view messages.",
		},
	},
})
